/* eslint-disable */

/**
 * Franklin's A/B test experiments.
 * The first value in each enum is the experiment default!
 */
export interface Experiments {
  ocr_card_linking_policy?: ExperimentsOcrCardLinkingPolicy;
  refunds_policy?: ExperimentsRefundsPolicy;
  force_p2p_coding_for_pulls?: ExperimentsForceP2PCodingForUndecidedPulls;
  public_test_policy?: ExperimentsPublicTestPolicy;
  private_test_policy?: ExperimentsPrivateTestPolicy;
  add_cash_enabled_policy?: ExperimentsAddCashEnabledPolicy;
  web_credit_card_linking_policy?: ExperimentsWebCreditCardLinkingPolicy;
  push_shazam_code_56?: ExperimentsPushShazamCode56;
  push_shazam_maestro_code_56?: ExperimentsPushShazamMaestroCode56;
  master_card_pull_mcc_policy?: ExperimentsMasterCardPullMccPolicy;
  cash_pro_sub_category_policy?: ExperimentsCashProSubCategoryPolicy;
  push_shazam_pulse_code_20?: ExperimentsPushShazamPulseCode20;
  unregulated_bin_pull_failover_policy?: ExperimentsUnregulatedBinPullFailoverPolicy;
  deposit_fee_status_policy?: ExperimentsDepositFeeStatusPolicy;
  auto_risk_approve_policy?: ExperimentsAutoRiskApprovePolicy;
  web_add_cash_policy?: ExperimentsWebAddCashPolicy;
  plaid_validation_override_policy?: ExperimentsPlaidValidationOverride;
  pull_via_acculynk_paysecure?: ExperimentsPullViaAcculynkPaysecure;
  reward_code_program_display_policy?: ExperimentsRewardCodeProgramDisplayPolicy;
  push_via_mastercard_send?: ExperimentsPushViaMasterCardSend;
  cost_routing_policy?: ExperimentsCostRoutingPolicy;
  onboarding_suggest_merge_policy?: ExperimentsOnboardingSuggestMergePolicy;
  card_passcode_update_policy?: ExperimentsCardPasscodeUpdatePolicy;
  issued_card_disabled_style_policy?: ExperimentsIssuedCardDisabledStylePolicy;
  delete_app_contacts_policy?: ExperimentsDeleteAppContactsPolicy;
  negative_balance_clawback_policy?: ExperimentsNegativeBalanceClawbackPolicy;
  support_callback_policy?: ExperimentsSupportCallbackPolicy;
  transfer_soft_descriptor_policy?: ExperimentsTransferSoftDescriptorPolicy;
  balance_auto_top_up_policy?: ExperimentsBalanceAutoTopUpPolicy;
  bitbank_funding_policy?: ExperimentsBitbankFundingPolicy;
  upcoming_fee_reminder_policy?: ExperimentsUpcomingFeeReminderPolicy;
  credit_card_linking_policy?: ExperimentsCreditCardLinkingPolicy;
  enhanced_security_login_policy?: ExperimentsEnhancedSecurityLoginPolicy;
  bitcoin_wallet_policy?: ExperimentsBitcoinWalletPolicy;
  government_id_verification_policy?: ExperimentsGovernmentIdVerificationPolicy;
  organic_new_customer_rate_plan_selection_policy?: ExperimentsOrganicNewCustomerRatePlanSelectionPolicy;
  sync_contacts_blocking_policy?: ExperimentsSyncContactsBlockingPolicy;
  verified_identity_status_level_policy?: ExperimentsVerifiedIdentityStatusLevelPolicy;
  idv_review_case_policy?: ExperimentsIdvReviewCasePolicy;
  redis_cache_get_issued_card_policy?: ExperimentsRedisCacheGetIssuedCardPolicy;
  recipient_confirmation_policy?: ExperimentsRecipientConfirmationPolicy;
  override_bitcoin_purchase_limit?: ExperimentsOverrideBitcoinPurchaseLimit;
  secure_login_contact_policy?: ExperimentsSecureLoginContactPolicy;
  sync_entities_android_policy?: ExperimentsSyncEntitiesInResponseContextAndroidPolicy;
  sync_entities_ios_policy?: ExperimentsSyncEntitiesInResponseContextIosPolicy;
  cutover_slow_debit_cash_out_policy?: ExperimentsCutoverSlowDebitCashOutPolicy;
  alias_event_creation_policy?: ExperimentsAliasEventCreationPolicy;
  set_name_first_onboarding_policy?: ExperimentsSetNameFirstOnboardingPolicy;
  redis_alias_cache_policy?: ExperimentsRedisAliasCachePolicy;
  override_bitcoin_purchase_rate_limit?: ExperimentsOverrideBitcoinPurchaseRateLimit;
  reward_status_app_api_transacter_mode_policy?: ExperimentsRewardStatusAppApiTransacterModePolicy;
  /** @deprecated */
  cross_border_payment_policy?: ExperimentsCrossBorderPaymentPolicy;
  get_app_config_app_api_transacter_mode_policy?: ExperimentsGetAppConfigAppApiTransacterModePolicy;
  cash_card_atm_policy?: ExperimentsCashCardAtmPolicy;
  card_transaction_support_button_policy?: ExperimentsCardTransactionSupportButtonPolicy;
  nfc_card_linking_policy?: ExperimentsNfcCardLinkingPolicy;
  payroll_onboarding_card_upsell_policy?: ExperimentsPayrollOnboardingCardUpsellPolicy;
  onboarding_card_upsell_policy?: ExperimentsOnboardingCardUpsellPolicy;
  use_binfo_for_star_pull_routing?: ExperimentsUseBinfoForStarPullRouting;
  /** @deprecated */
  web_activate_card_policy?: ExperimentsWebActivateCardPolicy;
  ios_dialogs_policy?: ExperimentsIosDialogsPolicy;
  high_value_target_login_policy?: ExperimentsHighValueTargetLoginPolicy;
  card_issuer_policy?: ExperimentsCardIssuerPolicy;
  transfer_flow_for_btc_exchange_policy?: ExperimentsTransferFlowForBtcExchangePolicy;
  customer_token_source?: ExperimentsCustomerTokenSource;
  pull_via_routy?: ExperimentsPullViaRouty;
  push_via_routy?: ExperimentsPushViaRouty;
  bitcoin_execute_purchase_policy?: ExperimentsBitcoinExecutePurchasePolicy;
  allow_app_icon_change_ios_policy?: ExperimentsAllowAppIconChangeIosPolicy;
  allow_bitcoin_operations_policy?: ExperimentsAllowBitcoinOperationsPolicy;
  card_event_process_policy?: ExperimentsCardEventProcessPolicy;
  cash_advance_offer_policy?: ExperimentsCashAdvanceOfferPolicy;
  cash_cash_out_sub_category_policy?: ExperimentsCashCashOutSubCategoryPolicy;
  auto_cash_out_toggle_policy?: ExperimentsAutoCashOutTogglePolicy;
  promo_in_status_result_policy?: ExperimentsPromoInStatusResultPolicy;
  cash_card_controls_in_settings_policy?: ExperimentsCashCardControlsInSettingsPolicy;
  show_usd_static_limits_policy?: ExperimentsShowUsdStaticLimitsPolicy;
  show_btc_static_limits_policy?: ExperimentsShowBtcStaticLimitsPolicy;
  misdirected_payment_confirmation_policy?: ExperimentsMisdirectedPaymentConfirmationPolicy;
  btc_phone_number_blocker_policy?: ExperimentsBtcPhoneNumberPolicy;
  replace_lost_card_policy?: ExperimentsReplaceLostCardPolicy;
  physical_card_activation_policy?: ExperimentsPhysicalCardActivationPolicy;
  square_loyalty_policy?: ExperimentsSquareLoyaltyPolicy;
  limit_bitcoin_withdrawal_policy?: ExperimentsLimitBitcoinWithdrawalPolicy;
  profile_in_response_context_policy?: ExperimentsProfileInResponseContextPolicy;
  web_auto_add_cash_policy?: ExperimentsWebAutoAddCashPolicy;
  app_user_interface_policy_ios?: ExperimentsAppUserInterfacePolicyIos;
  app_user_interface_policy_android?: ExperimentsAppUserInterfacePolicyAndroid;
  card_wiggle_affordance_policy?: ExperimentsCashCardDrawerWiggleAffordancePolicy;
  profile_in_response_context_android_policy?: ExperimentsProfileInResponseContextAndroidPolicy;
  profile_in_response_context_ios_policy?: ExperimentsProfileInResponseContextIosPolicy;
  web_region_selection_policy?: ExperimentsWebRegionSelectionPolicy;
  /** @deprecated */
  auto_add_cash_policy?: ExperimentsAutoAddCashPolicy;
  force_payment_confirmation_policy?: ExperimentsForcePaymentConfirmationPolicy;
  upsell_card_after_instant_cash_out_policy?: ExperimentsUpsellCardAfterInstantCashOutPolicy;
  sync_entities_on_foreground_ios_policy?: ExperimentsSyncEntitiesOnForegroundIosPolicy;
  apple_pay_app_to_app_verification_policy?: ExperimentsApplePayAppToAppVerificationPolicy;
  sync_entities_for_bitcoin_exchanges_policy?: ExperimentsSyncEntitiesForBitcoinExchangesPolicy;
  mcc_padder_policy?: ExperimentsMccPadderPolicy;
  app_review_prompt_behaviour_policy?: ExperimentsAppReviewPromptBehaviourPolicy;
  omnipay_staging_gateway_policy?: ExperimentsOmnipayStagingGatewayPolicy;
  third_party_trading_policy?: ExperimentsThirdPartyTradingPolicy;
  bankbook_balance_checks_policy?: ExperimentsBankbookBalanceChecksPolicy;
  uk_use_misc_mcc_policy?: ExperimentsUkUseMiscMccPolicy;
  cloud_contacts_policy?: ExperimentsCloudContactsPolicy;
  referral_program_gbr_policy?: ExperimentsReferralProgramGbrPolicy;
  reward_code_program_display_gbr_policy?: ExperimentsRewardCodeProgramDisplayGbrPolicy;
  native_referral_emails_ios_policy?: ExperimentsNativeReferralEmailsIosPolicy;
  native_referral_emails_android_policy?: ExperimentsNativeReferralEmailsAndroidPolicy;
  cash_out_drawer_behavior_policy?: ExperimentsCashOutDrawerBehaviorPolicy;
  cash_out_slider_initial_value_policy?: ExperimentsCashOutSliderInitialValuePolicy;
  upsell_card_activation_policy?: ExperimentsUpsellCardActivationPolicy;
  recipient_chooser_alias_preference_policy?: ExperimentsRecipientChooserAliasPreferenceIosPolicy;
  ach_pulls_special_customers_override?: ExperimentsAchPullsSpecialCustomersOverride;
  ach_pulls_in_us_policy?: ExperimentsAchPullsInUsPolicy;
  slow_bitcoin_withdrawal_policy?: ExperimentsSlowBitcoinWithdrawalPolicy;
  banklin_push_routing_policy?: ExperimentsBanklinPushRoutingPolicy;
  banklin_pull_routing_policy?: ExperimentsBanklinPullRoutingPolicy;
  itemized_selection_blocker_policy?: ExperimentsItemizedSelectionBlockerPolicy;
  onboarding_waitlist_policy?: ExperimentsOnboardingWaitlistPolicy;
  /** @deprecated */
  boost_for_all_policy?: ExperimentsBoostForAllPolicy;
  upsell_social_policy?: ExperimentsUpsellSocialPolicy;
  auto_add_cash_ach_policy?: ExperimentsAutoAddCashAchPolicy;
  boost_for_all_ios_policy?: ExperimentsBoostForAllIosPolicy;
  boost_for_all_android_policy?: ExperimentsBoostForAllAndroidPolicy;
  defer_address_update_in_banklin_policy?: ExperimentsDeferAddressUpdateInBanklinPolicy;
  card_delivered_notification_policy?: ExperimentsCardDeliveredNotificationPolicy;
  boost_selection_screen_copy_policy?: ExperimentsBoostSelectionScreenCopyPolicy;
  boost_no_selected_modal_ios_policy?: ExperimentsNoSelectedBoostModalIosPolicy;
  boost_no_selected_modal_android_policy?: ExperimentsNoSelectedBoostModalAndroidPolicy;
  onboarding_referral_code_policy_gb?: ExperimentsOnboardingReferralCodeGbPolicy;
  last_push_instrument_link_policy?: ExperimentsLastPushInstrumentLinkPolicy;
  email_contact_support_button_policy?: ExperimentsEmailContactSupportButtonPolicy;
  cashboard_ato_exposure_policy?: ExperimentsCashboardRequirePastHistoryPolicy;
  cashboard_disable_instrument_linking_policy?: ExperimentsCashboardDisableInstrumentLinkingPolicy;
  email_promotion_analytics_policy?: ExperimentsEmailPromotionAnalyticsPolicy;
  journal_boosts_policy?: ExperimentsJournalBoostsPolicy;
  change_card_design_policy?: ExperimentsChangeCardDesignPolicy;
  bitcoin_wallet_backend_type_policy?: ExperimentsBitcoinWalletBackendTypePolicy;
  payment_refund_policy?: ExperimentsPaymentRefundPolicy;
  plaid_relink_policy?: ExperimentsPlaidRelinkPolicy;
  idv_auto_fail_gb_policy?: ExperimentsIdvAutoFailGbPolicy;
  customer_suspension_policy?: ExperimentsCustomerSuspensionPolicy;
  support_text_policy?: ExperimentsSupportTextPolicy;
  merchant_colorized_avatar_policy?: ExperimentsMerchantColorizedAvatarPolicy;
  support_deflection_policy?: ExperimentsSupportDeflectionPolicy;
  support_contact_enabled_policy?: ExperimentsSupportContactEnabledPolicy;
  fake_risk_login_decision_policy?: ExperimentsFakeRiskLoginDecisionPolicy;
  sync_entity_processing_isolation_policy?: ExperimentsSyncEntityProcessingIsolationPolicy;
  machine_learning_case_prioritization_policy?: ExperimentsMachineLearningCasePrioritizationPolicy;
  register_sms_app_callback_token_policy?: ExperimentsRegisterSmsAppCallbackTokenPolicy;
  florida_address_blocker_policy?: ExperimentsFloridaAddressBlockerPolicy;
  /** @deprecated */
  blocker_ordering_policy?: ExperimentsBlockerOrderingPolicy;
  update_issued_card_from_profile_ios_policy?: ExperimentsUpdateIssuedCardFromProfileIosPolicy;
  bitcoin_w9_agreement_version?: ExperimentsBitcoinW9AgreementPolicy;
  receipt_promotions_referrals_policy?: ExperimentsReceiptPromotionsReferralsPolicy;
  bank_account_linking_policy?: ExperimentsBankAccountLinkingPolicy;
  heavy_customer_policy?: ExperimentsHeavyCustomersPolicy;
  skip_enhanced_verification_blockers_policy?: ExperimentsSkipEnhancedVerificationBlockersPolicy;
  physical_card_signature_approval_policy?: ExperimentsPhysicalCardSignatureApprovalPolicy;
  boost_for_some_ios_policy?: ExperimentsBoostForSomeIosPolicy;
  boost_for_some_android_policy?: ExperimentsBoostForSomeAndroidPolicy;
  /** @deprecated */
  valid_referral_reward_funding_instrument_policy?: ExperimentsValidReferralRewardFundingInstrumentPolicy;
  upsell_boost_exploration_policy?: ExperimentsUpsellBoostExplorationPolicy;
  shazam_digital_wallet_provisioning_policy?: ExperimentsShazamDigitalWalletProvisioningPolicy;
  bitcoin_w9_store_policy?: ExperimentsBitcoinW9StorePolicy;
  bitcoin_w9_send_to_taxman_policy?: ExperimentsBitcoinW9SendToTaxmanPolicy;
  payments_page_flow_policy?: ExperimentsPaymentsPageFlowPolicy;
  payment_receipt_enhanced_verification_policy?: ExperimentsPaymentReceiptEnhancedVerificationPolicy;
  autoresponder_autoblock_policy?: ExperimentsEnableAutoresponderAutoblockPolicy;
  bitcoin_1099b_send_to_taxman_policy?: ExperimentsBitcoin1099bSendToTaxmanPolicy;
  suspension_block_transfers_policy?: ExperimentsSuspensionBlockTransfersPolicy;
  evaluate_geo_location_policy?: ExperimentsEvaluateGeoLocationPolicy;
  ios_scrolling_quick_access_bar_policy?: ExperimentsIosScrollingQuickAccessBarPolicy;
  gb_payment_refund_policy?: ExperimentsGbPaymentRefundPolicy;
  resync_entities_revision_policy?: ExperimentsResyncEntitiesRevisionPolicy;
  override_cash_in_rate_limit_policy?: ExperimentsOverrideCashInRateLimitPolicy;
  soft_descriptor_prefix_policy?: ExperimentsUkSoftDescriptorPrefixPolicy;
  upsell_add_cash_boost_exploration_policy?: ExperimentsUpsellAddCashBoostExplorationPolicy;
  /** @deprecated */
  evaluate_global_address_policy?: ExperimentsEvaluateGlobalAddressPolicy;
  autoresponder_merge_policy?: ExperimentsEnableAutoresponderMergePolicy;
  enhanced_verification_include_contacts_policy?: ExperimentsEnhancedVerificationIncludeContactsPolicy;
  enhanced_verification_include_government_id_policy?: ExperimentsEnhancedVerificationIncludeGovernmentIdPolicy;
  enhanced_verification_include_plaid_policy?: ExperimentsEnhancedVerificationIncludePlaidPolicy;
  enhanced_verification_include_debit_card_policy?: ExperimentsEnhancedVerificationIncludeDebitCardPolicy;
  us_soft_descriptor_prefix_policy?: ExperimentsUsSoftDescriptorPrefixPolicy;
  gbp_outgoing_transfer_customer_policy?: ExperimentsGBPOutgoingTransferCustomerPolicy;
  banklin_reissue_card_policy?: ExperimentsBanklinReissueCardPolicy;
  banklin_denylisted_policy?: ExperimentsBanklinDenylistedPolicy;
  uk_payment_coding_category_policy?: ExperimentsUkPaymentCodingCategoryPolicy;
  uk_use_seller_mid_policy?: ExperimentsUkUseSellerMidPolicy;
  uk_use_combined_seller_attributes_policy?: ExperimentsUkUseCombinedSellerAttributesPolicy;
  instrument_refresh_policy?: ExperimentsInstrumentRefreshPolicy;
  upsell_activate_card_boost_exploration_policy?: ExperimentsUpsellActivateCardBoostExplorationPolicy;
  customer_snapshot_loading_policy?: ExperimentsCustomerSnapshotLoadingPolicy;
  multi_cards_policy?: ExperimentsMultiCardsPolicy;
  get_effective_customer_limits_transaction_policy?: ExperimentsGetEffectiveCustomerLimitsTransactionPolicy;
  override_bitcoin_deposit_limit?: ExperimentsOverrideBitcoinDepositLimit;
  link_square_issued_card_policy?: ExperimentsLinkSquareIssuedCardPolicy;
  minimum_transfer_amount_policy?: ExperimentsMinimumTransferAmountPolicy;
  emergency_card_policy?: ExperimentsEmergencyCardPolicy;
  link_card_app_api_transacter_mode_policy?: ExperimentsLinkCardAppApiTransacterModePolicy;
  enhanced_verification_ignored_plaid_settings_policy?: ExperimentsEnhancedVerificationIgnorePlaidSettingsPolicy;
  enhanced_verification_handle_government_id_policy?: ExperimentsEnhancedVerificationHandleGovernmentId;
  enhanced_verification_handle_contacts_policy?: ExperimentsEnhancedVerificationHandleContacts;
  enhanced_verification_handle_plaid_policy?: ExperimentsEnhancedVerificationHandlePlaid;
  suspended_customer_support_handling_policy?: ExperimentsSuspendedCustomerSupportHandlingPolicy;
  /** @deprecated */
  boost_treasure_hunt_policy?: ExperimentsBoostTreasureHuntPolicy;
  bitcoin_lightning_policy?: ExperimentsBitcoinLightningPolicy;
  remote_check_deposit_policy?: ExperimentsRemoteCheckDepositPolicy;
  pay_with_cash_pay_page_policy?: ExperimentsPayWithCashPayPagePolicy;
  demand_deposit_account_issuing_policy?: ExperimentsDemandDepositAccountIssuingPolicy;
  hackweek_auto_buy_bitcoin_for_ach_policy?: ExperimentsHackweekAutoBuyBitcoinForAchPolicy;
  institution_bank_link_policy?: ExperimentsInstitutionBankLinkPolicy;
  card_onboarding_disclosure_policy?: ExperimentsCardOnboardingDisclosurePolicy;
  suspension_bitcoin_policy?: ExperimentsSuspensionBitcoinPolicy;
  upfront_balance_checks_policy?: ExperimentsUpfrontBalanceChecksPolicy;
  card_process_bizbank_transaction_policy?: ExperimentsCardProcessBizbankTransactionPolicy;
  yodlee_form_blocker_policy?: ExperimentsYodleeFormBlockerPolicy;
  experimental_ach_soft_descriptor_policy?: ExperimentsExperimentalAchSoftDescriptorPolicy;
  email_sending_policy?: ExperimentsEmailSendingPolicy;
  plasma_flows_policy?: ExperimentsPlasmaFlowsPolicy;
  payment_plasma_migration_policy?: ExperimentsPaymentPlasmaMigrationPolicy;
  cashtag_page_refresh_spring_2019_policy?: ExperimentsCashtagPageRefreshSpring2019Policy;
  receipt_page_refresh_spring_2019_policy?: ExperimentsReceiptPageRefreshSpring2019Policy;
  banklin_ledgering_policy?: ExperimentsBanklinLedgeringPolicy;
  plasma_remove_boost_flow_policy?: ExperimentsPlasmaRemoveBoostFlowPolicy;
  plasma_add_boost_flow_policy?: ExperimentsPlasmaAddBoostFlowPolicy;
  uk_dynamic_pull_routing_policy?: ExperimentsUkDynamicPullRoutingPolicy;
  sync_values_migration_for_profile_assets?: ExperimentsSyncValuesMigrationForProfileAssets;
  free_atm_status_policy?: ExperimentsFreeAtmStatusPolicy;
  unlinked_refund_rule_policy?: ExperimentsUnlinkedRefundRulePolicy;
  business_payments_expiration_policy?: ExperimentsBusinessPaymentsExpirationPolicy;
  onboarding_referral_code_us_policy?: ExperimentsOnboardingReferralCodeUsPolicy;
  bill_from_outside_of_contacts_policy?: ExperimentsBillFromOutsideOfContactsPolicy;
  travel_boost_policy?: ExperimentsTravelBoostPolicy;
  white_card_policy?: ExperimentsWhiteCardPolicy;
  btc_sell_idv_blocker_policy?: ExperimentsBtcSellIdvBlockerPolicy;
  apple_pay_with_tabs_policy?: ExperimentsApplePayWithTabsPolicy;
  transaction_related_sync_entities_migration_policy?: ExperimentsTransactionRelatedSyncEntitiesMigrationPolicy;
  slow_ach_cash_out_policy?: ExperimentsSlowAchCashOutPolicy;
  customer_address_master_card_payment_policy?: ExperimentsCustomerAddressMasterCardPaymentPolicy;
  twin_operator_concurrent_modifications_policy?: ExperimentsTwinOperatorConcurrentModificationsPolicy;
  customer_statement_name_master_card_payment_policy?: ExperimentsCustomerStatementNameMasterCardPaymentPolicy;
  master_card_statement_last_name_substitution_policy?: ExperimentsMasterCardStatementLastNameSubstitutionPolicy;
  clientsync_payments_migration_policy?: ExperimentsClientSyncPaymentsMigrationPolicy;
  money_mover_migration_policy?: ExperimentsMoneyMoverMigrationPolicy;
  bitcoin_transaction_pricing_policy?: ExperimentsBitcoinTransactionPricingPolicy;
  payment_evently_migration?: ExperimentsPaymentEventlyMigration;
  amex_subcategory_conversion_policy?: ExperimentsAmexSubcategoryConversionPolicy;
  bitcoin_before_cutoff_pricing_policy?: ExperimentsBitcoinBeforeCutoffPricingPolicy;
  amex_mcc_and_address_override_policy?: ExperimentsAmexMccAndAddressOverridePolicy;
  expensive_instruments_for_invited_customers_referral_payout_policy?:
    ExperimentsExpensiveInstrumentsForInvitedCustomersReferralPayoutPolicy;
  unused_instruments_for_invited_customers_referral_payout_policy?:
    ExperimentsUnusedInstrumentsForInvitedCustomersReferralPayoutPolicy;
  idv_for_invited_customers_referral_payout_policy?: ExperimentsIdvForInvitedCustomersReferralPayoutPolicy;
  bitcoin_transaction_graduated_pricing_policy?: ExperimentsBitcoinTransactionGraduatedPricingPolicy;
  bitcoin_transaction_graduated_pricing_v2_policy?: ExperimentsBitcoinTransactionGraduatedPricingV2Policy;
  bitcoin_before_cutoff_transaction_graduated_pricing_policy?:
    ExperimentsBitcoinBeforeCutoffTransactionGraduatedPricingPolicy;
}

/** Policy used to determine if the customer can use OCR during card linking. */
export enum ExperimentsOcrCardLinkingPolicy {
  OCR_DISABLED = "OCR_DISABLED",
  OCR_ENABLED = "OCR_ENABLED",
}

/**
 * Policy used to determine if payments can be refunded. This experiment is active as of August
 * 2018 as a kill switch in case we run into refund fraud. Talk to apaulin@ before removing.
 */
export enum ExperimentsRefundsPolicy {
  REFUNDS_ENABLED = "REFUNDS_ENABLED",
  REFUNDS_DISABLED = "REFUNDS_DISABLED",
}

/**
 * When the rate policy is UNDECIDED for a pull and this experiment is enabled for the user, use
 * P2P coding instead.
 *
 * This experiment is in use as of September 2018 and should be occasionally updated to reflect
 * the ratio of P2P pulls (FORCE_P2P) vs Business pulls (DO_NOT_FORCE_P2P). The reasoning is that,
 * when sending money to a new recipient, we don't know if it's a business customer, but to be
 * fair to the networks (which charge different rates for commercial pulls) we should still claim
 * a certain percentage of these UNDECIDED pulls as commercial.
 */
export enum ExperimentsForceP2PCodingForUndecidedPulls {
  DO_NOT_FORCE_P2P = "DO_NOT_FORCE_P2P",
  FORCE_P2P = "FORCE_P2P",
}

/** Experiment for tests, to avoid being dependent on any specific real experiment. */
export enum ExperimentsPublicTestPolicy {
  PUBLIC_TEST_POLICY_A = "PUBLIC_TEST_POLICY_A",
  PUBLIC_TEST_POLICY_B = "PUBLIC_TEST_POLICY_B",
}

/** Private experiment for tests, to avoid being dependent on any specific real experiment. */
export enum ExperimentsPrivateTestPolicy {
  PRIVATE_TEST_POLICY_A = "PRIVATE_TEST_POLICY_A",
  PRIVATE_TEST_POLICY_B = "PRIVATE_TEST_POLICY_B",
}

/**
 * Policy to decide whether or not we display "Add Cash" in the apps. Still in use as of September
 * 2018 to bypass risk for certain trusted customers (i.e. $Jack, Square Payroll Master Account).
 */
export enum ExperimentsAddCashEnabledPolicy {
  /** ADD_CASH_ENABLED_BYPASSING_RISK - Always enabled for the customer, no matter what the risk systems say. Used for testing. */
  ADD_CASH_ENABLED_BYPASSING_RISK = "ADD_CASH_ENABLED_BYPASSING_RISK",
  /** ADD_CASH_ENABLED - Enabled, provided that the risk systems also think the customer is good. */
  ADD_CASH_ENABLED = "ADD_CASH_ENABLED",
  /** ADD_CASH_ENABLED_WITH_ADDRESS_CHECK - Enabled, provided that the risk systems checks pass and the customer has an address on file. */
  ADD_CASH_ENABLED_WITH_ADDRESS_CHECK = "ADD_CASH_ENABLED_WITH_ADDRESS_CHECK",
  /** ADD_CASH_DISABLED - Always disabled for the customer. */
  ADD_CASH_DISABLED = "ADD_CASH_DISABLED",
}

/**
 * Policy to control whether credit cards can be linked on the web. Still in use as of September
 * 2018 to enable web linking for certain trusted customers (i.e. Reimbursements From Square).
 */
export enum ExperimentsWebCreditCardLinkingPolicy {
  WEB_CREDIT_CARD_LINKING_DISABLED = "WEB_CREDIT_CARD_LINKING_DISABLED",
  WEB_CREDIT_CARD_LINKING_ENABLED = "WEB_CREDIT_CARD_LINKING_ENABLED",
}

/**
 * The Shazam code 56 rollout is to send 56's for MAESTRO and PULSE, also to populate
 * First and Last Name and Sender ZIP and City.
 */
export enum ExperimentsPushShazamCode56 {
  PUSH_SHAZAM_CODE_56_DISABLED = "PUSH_SHAZAM_CODE_56_DISABLED",
  PUSH_SHAZAM_CODE_56_ENABLED = "PUSH_SHAZAM_CODE_56_ENABLED",
}

/** Special override for MAESTRO allows us to control code 56 based on BINs. */
export enum ExperimentsPushShazamMaestroCode56 {
  PUSH_SHAZAM_MAESTRO_CODE_56_DISABLED = "PUSH_SHAZAM_MAESTRO_CODE_56_DISABLED",
  PUSH_SHAZAM_MAESTRO_CODE_56_ENABLED = "PUSH_SHAZAM_MAESTRO_CODE_56_ENABLED",
}

/** If we should use MCC 4829 for mastercard during pulls. */
export enum ExperimentsMasterCardPullMccPolicy {
  DISABLE_MASTER_CARD_PULL_MCC = "DISABLE_MASTER_CARD_PULL_MCC",
  ENABLE_MASTER_CARD_PULL_MCC = "ENABLE_MASTER_CARD_PULL_MCC",
}

/** Whether or not to code as Cash Pro Purchase for merchant Cash pushes (non-Instant Deposit) */
export enum ExperimentsCashProSubCategoryPolicy {
  CASH_PRO_SUBCATEGORY_DISBALED = "CASH_PRO_SUBCATEGORY_DISBALED",
  CASH_PRO_SUBCATEGORY_ENABLED = "CASH_PRO_SUBCATEGORY_ENABLED",
}

/** Allow code 20 fallbacks to PULSE via Shazam. */
export enum ExperimentsPushShazamPulseCode20 {
  PUSH_SHAZAM_PULSE_CODE_20_DISABLED = "PUSH_SHAZAM_PULSE_CODE_20_DISABLED",
  PUSH_SHAZAM_PULSE_CODE_20_ENABLED = "PUSH_SHAZAM_PULSE_CODE_20_ENABLED",
}

export enum ExperimentsUnregulatedBinPullFailoverPolicy {
  FAILOVER_UNREGULATED_PULLS_TO_ESPERANTO = "FAILOVER_UNREGULATED_PULLS_TO_ESPERANTO",
  DONT_FAILOVER_UNREGULATED_PULLS_TO_ESPERANTO = "DONT_FAILOVER_UNREGULATED_PULLS_TO_ESPERANTO",
}

/** Deposit fee status policy that controls charging for instant deposits for new customers. */
export enum ExperimentsDepositFeeStatusPolicy {
  /**
   * NO_FEE_FOR_INSTANT_DEPOSITS - This value is deprecated. Use BPS_FEE_150_CUTOVER for US region.
   * For other regions, create another experiment.
   *
   * @deprecated
   */
  NO_FEE_FOR_INSTANT_DEPOSITS = "NO_FEE_FOR_INSTANT_DEPOSITS",
  /**
   * BPS_FEE_FOR_INSTANT_DEPOSITS - This value is deprecated. Use BPS_FEE_150_CUTOVER for US region.
   * For other regions, create another experiment.
   *
   * @deprecated
   */
  BPS_FEE_FOR_INSTANT_DEPOSITS = "BPS_FEE_FOR_INSTANT_DEPOSITS",
  /**
   * BPS_FEE_150 - This value is deprecated. Use BPS_FEE_150_CUTOVER for US region.
   * For other regions, create another experiment.
   *
   * @deprecated
   */
  BPS_FEE_150 = "BPS_FEE_150",
  /**
   * BPS_FEE_150_CUTOVER - This value is deprecated. Use BPS_FEE_175 for US region.
   * For other regions, create another experiment.
   *
   * @deprecated
   */
  BPS_FEE_150_CUTOVER = "BPS_FEE_150_CUTOVER",
  /**
   * BPS_FEE_175 - New customers get BPS_FEE_175 deposit fee status. Old customers are migrated from all the
   * deprecated statuses.
   */
  BPS_FEE_175 = "BPS_FEE_175",
}

/**
 * Optimistically skips the WAITING_ON_RISK step in the state machine and advances.
 * GO_THROUGH_RISK: Regular behavior (always go through risk)
 * SKIP_RISK_UNLESS_SUSPICIOUS: Do a simple check to determine whether it's a suspicious payment. If so: go through risk; else: skip
 *
 * This policy is used to reduce traffic from frisky, speeding payment completion up.
 * We want to process payments as fast as possible so that we can receive instant deposit fees,
 * which would be reimbursed if we fail to meet our SLA.
 *
 * Still in use as of August 2019.
 */
export enum ExperimentsAutoRiskApprovePolicy {
  GO_THROUGH_RISK = "GO_THROUGH_RISK",
  SKIP_RISK_UNLESS_SUSPICIOUS = "SKIP_RISK_UNLESS_SUSPICIOUS",
}

/**
 * Policy to decide whether or not we display "Add Cash" on the web. Still in use as of September
 * 2018 to enable adding cash from the web for certain trusted customers (i.e. "Cash App").
 */
export enum ExperimentsWebAddCashPolicy {
  ADD_CASH_DISABLED_IN_WEB = "ADD_CASH_DISABLED_IN_WEB",
  ADD_CASH_ENABLED_IN_WEB = "ADD_CASH_ENABLED_IN_WEB",
}

/** Policy for testing, allows skipping validation with real Plaid to return a known response. */
export enum ExperimentsPlaidValidationOverride {
  VALIDATE_WITH_PLAID = "VALIDATE_WITH_PLAID",
  PLAID_TOKEN_INVALID = "PLAID_TOKEN_INVALID",
  PLAID_CREDENTIALS_EXPIRED = "PLAID_CREDENTIALS_EXPIRED",
  PLAID_ACCOUNT_VALID = "PLAID_ACCOUNT_VALID",
}

/**
 * Enabling this experiment will add a high priority route for payment pulls via Acculynk
 * Paysecure gateway.
 */
export enum ExperimentsPullViaAcculynkPaysecure {
  PAYSECURE_PULL_DISABLED = "PAYSECURE_PULL_DISABLED",
  PAYSECURE_PULL_ENABLED = "PAYSECURE_PULL_ENABLED",
}

/**
 * Enabling this experiment changes the kind of reward code displayed to the customer. If a
 * customer does not have that kind of reward code yet, a new code for that program will be
 * created.
 * Update the following wiki once a new reward code program is released:
 * https://wiki.sqcorp.co/display/Support/Cash+Referral+Program+Updates
 *
 * NOTE: Region specific policies are available as well. Ex. RewardCodeProgramDisplayUkPolicy
 */
export enum ExperimentsRewardCodeProgramDisplayPolicy {
  FIVE_BY_FIVE = "FIVE_BY_FIVE",
  TEN_BY_TEN = "TEN_BY_TEN",
  TEN_BY_FIVE = "TEN_BY_FIVE",
  TWENTY_BY_FIVE = "TWENTY_BY_FIVE",
  TWENTY_FIVE_BY_FIVE = "TWENTY_FIVE_BY_FIVE",
  FIFTY_BY_FIVE = "FIFTY_BY_FIVE",
  FIVE_BY_TEN = "FIVE_BY_TEN",
  TEN_BY_TEN_REPLICATING_1 = "TEN_BY_TEN_REPLICATING_1",
  TEN_BY_TEN_REPLICATING_2 = "TEN_BY_TEN_REPLICATING_2",
  TEN_BY_TEN_REPLICATING_3 = "TEN_BY_TEN_REPLICATING_3",
  TEN_BY_TEN_REPLICATING_4 = "TEN_BY_TEN_REPLICATING_4",
  TEN_BY_TEN_REPLICATING_5 = "TEN_BY_TEN_REPLICATING_5",
  TEN_BY_TEN_REPLICATING_6 = "TEN_BY_TEN_REPLICATING_6",
  TEN_BY_TEN_REPLICATING_7 = "TEN_BY_TEN_REPLICATING_7",
  TEN_BY_TEN_REPLICATING_8 = "TEN_BY_TEN_REPLICATING_8",
  TEN_BY_TEN_REPLICATING_9 = "TEN_BY_TEN_REPLICATING_9",
  TEN_BY_TEN_REPLICATING_10 = "TEN_BY_TEN_REPLICATING_10",
  TEN_BY_TEN_REPLICATING_11 = "TEN_BY_TEN_REPLICATING_11",
  TEN_BY_TEN_REPLICATING_12 = "TEN_BY_TEN_REPLICATING_12",
  TEN_BY_TEN_REPLICATING_13 = "TEN_BY_TEN_REPLICATING_13",
  TEN_BY_TEN_REPLICATING_14 = "TEN_BY_TEN_REPLICATING_14",
  TEN_BY_TEN_REPLICATING_15 = "TEN_BY_TEN_REPLICATING_15",
  FIFTEEN_BY_FIVE = "FIFTEEN_BY_FIVE",
  FIVE_BY_FIFTEEN = "FIVE_BY_FIFTEEN",
  TEN_BY_FIFTEEN = "TEN_BY_FIFTEEN",
  FIFTEEN_BY_TEN = "FIFTEEN_BY_TEN",
  FIFTEEN_BY_FIFTEEN = "FIFTEEN_BY_FIFTEEN",
  ZERO_BY_FIVE = "ZERO_BY_FIVE",
  ZERO_BY_TEN = "ZERO_BY_TEN",
  THIRTY_BY_FIFTEEN = "THIRTY_BY_FIFTEEN",
  THIRTY_BY_TEN = "THIRTY_BY_TEN",
  TWENTY_FIVE_BY_FIFTEEN = "TWENTY_FIVE_BY_FIFTEEN",
  TWENTY_FIVE_BY_TEN = "TWENTY_FIVE_BY_TEN",
  TWENTY_BY_FIFTEEN = "TWENTY_BY_FIFTEEN",
  TWENTY_BY_TEN = "TWENTY_BY_TEN",
  THIRTY_BY_FIVE = "THIRTY_BY_FIVE",
  ZERO_BY_FIFTEEN = "ZERO_BY_FIFTEEN",
}

/**
 * Enabling this experiment will add a high priority route for payment pushes via MasterCard
 * Send gateway.
 */
export enum ExperimentsPushViaMasterCardSend {
  MASTERCARD_SEND_PUSH_DISABLED = "MASTERCARD_SEND_PUSH_DISABLED",
  MASTERCARD_SEND_PUSH_ENABLED = "MASTERCARD_SEND_PUSH_ENABLED",
  MASTERCARD_SEND_PRIORITY_PUSH_ENABLED = "MASTERCARD_SEND_PRIORITY_PUSH_ENABLED",
}

/** Policy to control cost based routing. */
export enum ExperimentsCostRoutingPolicy {
  COST_ROUTING_DISABLED = "COST_ROUTING_DISABLED",
  COST_ROUTING_ENABLED = "COST_ROUTING_ENABLED",
}

/** Controls if we suggest merge in onboarding after an instrument is linked. */
export enum ExperimentsOnboardingSuggestMergePolicy {
  SUGGEST_MERGE_DISABLED = "SUGGEST_MERGE_DISABLED",
  SUGGEST_MERGE_ENABLED = "SUGGEST_MERGE_ENABLED",
}

/** Controls if we send Card passcode code updates to Banklin/Shazam/Plastic. */
export enum ExperimentsCardPasscodeUpdatePolicy {
  SEND_PASSCODE_UPDATES_TO_BANKLIN_DISABLED = "SEND_PASSCODE_UPDATES_TO_BANKLIN_DISABLED",
  SEND_PASSCODE_UPDATES_TO_BANKLIN_ENABLED = "SEND_PASSCODE_UPDATES_TO_BANKLIN_ENABLED",
}

/** Controls what visual treatment clients should give an issued card when disabled. */
export enum ExperimentsIssuedCardDisabledStylePolicy {
  ISSUED_CARD_DISABLED_STYLE_WHITE = "ISSUED_CARD_DISABLED_STYLE_WHITE",
  ISSUED_CARD_DISABLED_STYLE_GREY = "ISSUED_CARD_DISABLED_STYLE_GREY",
}

export enum ExperimentsDeleteAppContactsPolicy {
  SET_DELETED_FLAG = "SET_DELETED_FLAG",
  REALLY_DELETE = "REALLY_DELETE",
}

export enum ExperimentsNegativeBalanceClawbackPolicy {
  DO_NOT_CLAWBACK = "DO_NOT_CLAWBACK",
  CLAWBACK = "CLAWBACK",
}

/**
 * Gates whether a support callback option is presented, subject to other constraints.
 * Tags are ordered by smallest to largest group of customers having access to the option.
 */
export enum ExperimentsSupportCallbackPolicy {
  CALLBACK_DISABLED_NO_OVERRIDES = "CALLBACK_DISABLED_NO_OVERRIDES",
  CALLBACK_DISABLED = "CALLBACK_DISABLED",
  CALLBACK_ENABLED_FOR_CAVIAR_COURIER_CUSTOMERS = "CALLBACK_ENABLED_FOR_CAVIAR_COURIER_CUSTOMERS",
  CALLBACK_ENABLED_FOR_DIRECT_DEPOSIT_30_DAY_CUSTOMERS = "CALLBACK_ENABLED_FOR_DIRECT_DEPOSIT_30_DAY_CUSTOMERS",
  CALLBACK_ENABLED_FOR_DIRECT_DEPOSIT_CUSTOMERS = "CALLBACK_ENABLED_FOR_DIRECT_DEPOSIT_CUSTOMERS",
  CALLBACK_ENABLED_FOR_CARD_CUSTOMERS = "CALLBACK_ENABLED_FOR_CARD_CUSTOMERS",
  CALLBACK_ENABLED_FOR_ALL_CARD_CUSTOMERS = "CALLBACK_ENABLED_FOR_ALL_CARD_CUSTOMERS",
  /** CALLBACK_ENABLED - Tags are out of order. Next tag 9; */
  CALLBACK_ENABLED = "CALLBACK_ENABLED",
}

/** Prevents banks from differentiating between transfers and payments. */
export enum ExperimentsTransferSoftDescriptorPolicy {
  USE_DEFAULT_DESCRIPTION = "USE_DEFAULT_DESCRIPTION",
  USE_LAST_SENDER_NAME = "USE_LAST_SENDER_NAME",
}

/** If and how we should top up the balance automatically. */
export enum ExperimentsBalanceAutoTopUpPolicy {
  /** TOP_UP_DISABLED - No automated balance top up. */
  TOP_UP_DISABLED = "TOP_UP_DISABLED",
  /** INLINE_TOP_UP_LOW_FUNDS - If an incoming auth will fail due to insufficient funds, top up inline. */
  INLINE_TOP_UP_LOW_FUNDS = "INLINE_TOP_UP_LOW_FUNDS",
}

/** Whether or not to use a bitcoin balance as a funding source. */
export enum ExperimentsBitbankFundingPolicy {
  /** BITBANK_DISABLED - No automated balance transfers. */
  BITBANK_DISABLED = "BITBANK_DISABLED",
  /** BITBANK_FUND_ALWAYS - On any incoming auth, fund from the bitbank balance. */
  BITBANK_FUND_ALWAYS = "BITBANK_FUND_ALWAYS",
}

/** Whether to send notifications about upcoming subscriptions fees as detected by Banklin. */
export enum ExperimentsUpcomingFeeReminderPolicy {
  NO_UPCOMING_FEE_REMINDER = "NO_UPCOMING_FEE_REMINDER",
  SEND_UPCOMING_FEE_REMINDER = "SEND_UPCOMING_FEE_REMINDER",
}

/** Policy to prevent risky credit card links from being attempted. */
export enum ExperimentsCreditCardLinkingPolicy {
  CREDIT_CARD_LINKING_ENABLED = "CREDIT_CARD_LINKING_ENABLED",
  CREDIT_CARD_REQUIRES_PRIOR_DEBIT_CARD = "CREDIT_CARD_REQUIRES_PRIOR_DEBIT_CARD",
}

/** Whether enhanced security is triggered for logins on supported clients. */
export enum ExperimentsEnhancedSecurityLoginPolicy {
  ENHANCED_SECURITY_LOGIN_DISABLED = "ENHANCED_SECURITY_LOGIN_DISABLED",
  ENHANCED_SECURITY_LOGIN_ENABLED = "ENHANCED_SECURITY_LOGIN_ENABLED",
  /** ENHANCED_SECURITY_LOGIN_FORCED - Every login will hit enhanced security, even on previously used devices. Added for testing. */
  ENHANCED_SECURITY_LOGIN_FORCED = "ENHANCED_SECURITY_LOGIN_FORCED",
}

/** Whether to allow the account access to a bitcoin wallet. */
export enum ExperimentsBitcoinWalletPolicy {
  DISABLE_BITCOIN_WALLET = "DISABLE_BITCOIN_WALLET",
  ENABLE_BITCOIN_WALLET = "ENABLE_BITCOIN_WALLET",
}

/** Policy that controls how government IDs are verified. This is for testing use only. */
export enum ExperimentsGovernmentIdVerificationPolicy {
  NORMAL_VERIFICATION = "NORMAL_VERIFICATION",
  /** LENIENT_VERIFICATION - Allow expired and unsupported region government IDs to pass verification. */
  LENIENT_VERIFICATION = "LENIENT_VERIFICATION",
}

/**
 * Whether to force an organic (= not invited, referred, or paid)
 * new customer to pick a rate plan.
 */
export enum ExperimentsOrganicNewCustomerRatePlanSelectionPolicy {
  FORCE_RATE_PLAN_SELECTION = "FORCE_RATE_PLAN_SELECTION",
  DEFER_RATE_PLAN_SELECTION = "DEFER_RATE_PLAN_SELECTION",
}

/** Whether to allow or (temporarily) block contact syncing. */
export enum ExperimentsSyncContactsBlockingPolicy {
  ALLOW_CONTACT_SYNC = "ALLOW_CONTACT_SYNC",
  BLOCK_CONTACT_SYNC = "BLOCK_CONTACT_SYNC",
}

/** Policy that controls the status level we assign a customer after they pass IDV. */
export enum ExperimentsVerifiedIdentityStatusLevelPolicy {
  UPGRADE_TO_GOLD = "UPGRADE_TO_GOLD",
  UPGRADE_TO_GOLD_10K = "UPGRADE_TO_GOLD_10K",
}

/** Policy that controls whether to create a regulator case for an IDV review. */
export enum ExperimentsIdvReviewCasePolicy {
  DO_NOT_CREATE_CASE = "DO_NOT_CREATE_CASE",
  CREATE_CASE_WHEN_REVIEW_REQUESTED = "CREATE_CASE_WHEN_REVIEW_REQUESTED",
  CREATE_CASE_WHEN_REVIEW_INCONCLUSIVE = "CREATE_CASE_WHEN_REVIEW_INCONCLUSIVE",
}

/** Policy that controls whether to cache calls to GetIssuedCardAppApi. */
export enum ExperimentsRedisCacheGetIssuedCardPolicy {
  DO_NOT_CACHE_GET_ISSUED_CARD = "DO_NOT_CACHE_GET_ISSUED_CARD",
  CACHE_GET_ISSUED_CARD = "CACHE_GET_ISSUED_CARD",
  /**
   * VERIFY_GET_ISSUED_CARD - Verifies the cached redis issued card value (if any) with the issued card value computed
   * using the database.
   */
  VERIFY_GET_ISSUED_CARD = "VERIFY_GET_ISSUED_CARD",
}

export enum ExperimentsRecipientConfirmationPolicy {
  NO_RECIPIENT_CONFIRMATION_BLOCKER = "NO_RECIPIENT_CONFIRMATION_BLOCKER",
  CONFIRMATION_BLOCKER_FOR_INACTIVE_RECIPIENTS = "CONFIRMATION_BLOCKER_FOR_INACTIVE_RECIPIENTS",
}

/** Customers in this experiment will not be subject to the default purchase limits of the system */
export enum ExperimentsOverrideBitcoinPurchaseLimit {
  OVERRIDE_PURCHASE_LIMIT_DISABLED = "OVERRIDE_PURCHASE_LIMIT_DISABLED",
  OVERRIDE_PURCHASE_LIMIT_ENABLED = "OVERRIDE_PURCHASE_LIMIT_ENABLED",
}

/** Policy that controls if customers can login via verifying contacts. */
export enum ExperimentsSecureLoginContactPolicy {
  SECURE_LOGIN_CONTACTS_DISABLED = "SECURE_LOGIN_CONTACTS_DISABLED",
  SECURE_LOGIN_CONTACTS_ENABLED = "SECURE_LOGIN_CONTACTS_ENABLED",
}

/** As of September 2018 this is exposed as a feature flag to clients. */
export enum ExperimentsSyncEntitiesInResponseContextAndroidPolicy {
  OMIT_SYNC_ENTITIES_IN_ANDROID = "OMIT_SYNC_ENTITIES_IN_ANDROID",
  INCLUDE_SYNC_ENTITIES_IN_ANDROID = "INCLUDE_SYNC_ENTITIES_IN_ANDROID",
}

/** As of September 2018 this is exposed as a feature flag to clients. */
export enum ExperimentsSyncEntitiesInResponseContextIosPolicy {
  OMIT_SYNC_ENTITIES_IN_IOS = "OMIT_SYNC_ENTITIES_IN_IOS",
  INCLUDE_SYNC_ENTITIES_IN_IOS = "INCLUDE_SYNC_ENTITIES_IN_IOS",
}

/**
 * Policy that controls if customers who earlier had free slow deposits via debit should
 * be required to use a bank account for free slow cash outs.
 */
export enum ExperimentsCutoverSlowDebitCashOutPolicy {
  CUTOVER_SLOW_DEBIT_CASH_OUT_ENABLED = "CUTOVER_SLOW_DEBIT_CASH_OUT_ENABLED",
  CUTOVER_SLOW_DEBIT_CASH_OUT_DISABLED = "CUTOVER_SLOW_DEBIT_CASH_OUT_DISABLED",
}

/**
 * Policy that controls if we create alias events inside of a transaction synchronously, or
 * enqueue a job to eventually create the event.
 */
export enum ExperimentsAliasEventCreationPolicy {
  CREATE_ALIAS_EVENT_SYNC = "CREATE_ALIAS_EVENT_SYNC",
  CREATE_ALIAS_EVENT_ASYNC = "CREATE_ALIAS_EVENT_ASYNC",
}

/** Policy that controls if we ask for full name before anything else in onboarding flow. */
export enum ExperimentsSetNameFirstOnboardingPolicy {
  SET_NAME_FIRST_DISABLED = "SET_NAME_FIRST_DISABLED",
  SET_NAME_FIRST_ENABLED = "SET_NAME_FIRST_ENABLED",
}

/** Policy to control redis caching of aliases. */
export enum ExperimentsRedisAliasCachePolicy {
  /** ALIAS_CACHING_DISABLED - Aliases are always fetched from the db. */
  ALIAS_CACHING_DISABLED = "ALIAS_CACHING_DISABLED",
  /**
   * ALIAS_CACHING_VERIFICATION_MODE - In verification mode, alias values from the cache (if exists) is compared against the value
   * from the db. The value from the db is returned always rather than the cached value.
   */
  ALIAS_CACHING_VERIFICATION_MODE = "ALIAS_CACHING_VERIFICATION_MODE",
  /**
   * ALIAS_CACHING_ENABLED - Aliases are fetched from redis cache and returned. If not found in redis, it is loaded from
   * db.
   */
  ALIAS_CACHING_ENABLED = "ALIAS_CACHING_ENABLED",
}

/** Customers in this experiment will not be subject to the default purchase rate limits of the system */
export enum ExperimentsOverrideBitcoinPurchaseRateLimit {
  OVERRIDE_PURCHASE_RATE_LIMIT_DISABLED = "OVERRIDE_PURCHASE_RATE_LIMIT_DISABLED",
  OVERRIDE_PURCHASE_RATE_LIMIT_ENABLED = "OVERRIDE_PURCHASE_RATE_LIMIT_ENABLED",
}

/** Policy to control if a session is read-only or read-write for GetRewardStatusAppApi. */
export enum ExperimentsRewardStatusAppApiTransacterModePolicy {
  REWARD_STATUS_TRANSACTER_READ_WRITE = "REWARD_STATUS_TRANSACTER_READ_WRITE",
  REWARD_STATUS_TRANSACTER_READ_ONLY = "REWARD_STATUS_TRANSACTER_READ_ONLY",
}

/**
 * Policy that controls whether we allow cross-border payments. As of September 2018 this is
 * exposed as a feature flag to clients.
 */
export enum ExperimentsCrossBorderPaymentPolicy {
  /** @deprecated */
  CROSS_BORDER_PAYMENTS_DISABLED = "CROSS_BORDER_PAYMENTS_DISABLED",
  /** @deprecated */
  CROSS_BORDER_PAYMENTS_ENABLED = "CROSS_BORDER_PAYMENTS_ENABLED",
}

/** Policy to control if a session is read-only or read-write for GetAppConfigAppApi. */
export enum ExperimentsGetAppConfigAppApiTransacterModePolicy {
  GET_APP_CONFIG_APP_API_TRANSACTER_READ_WRITE = "GET_APP_CONFIG_APP_API_TRANSACTER_READ_WRITE",
  GET_APP_CONFIG_APP_API_TRANSACTER_READ_ONLY = "GET_APP_CONFIG_APP_API_TRANSACTER_READ_ONLY",
}

/** Policy to control if a customer can use their Cash Card at an ATM. */
export enum ExperimentsCashCardAtmPolicy {
  NO_ATM_ACCESS = "NO_ATM_ACCESS",
  ATM_ACCESS_WITH_NO_DECLINE_REASONS = "ATM_ACCESS_WITH_NO_DECLINE_REASONS",
  ATM_ACCESS_WITH_FRISKY_DECLINE_REASONS = "ATM_ACCESS_WITH_FRISKY_DECLINE_REASONS",
}

/**
 * Policy for showing the support button in card transaction receipts. As of September 2018 this
 * is exposed as a feature flag to clients.
 */
export enum ExperimentsCardTransactionSupportButtonPolicy {
  CARD_SUPPORT_BUTTON_SHOWN = "CARD_SUPPORT_BUTTON_SHOWN",
  CARD_SUPPORT_BUTTON_NOT_SHOWN = "CARD_SUPPORT_BUTTON_NOT_SHOWN",
}

/** Policy used to determine if the customer can use NFC during card linking. */
export enum ExperimentsNfcCardLinkingPolicy {
  NFC_CARD_LINKING_DISABLED = "NFC_CARD_LINKING_DISABLED",
  NFC_CARD_LINKING_ENABLED = "NFC_CARD_LINKING_ENABLED",
}

/**
 * Policy to control if customers with a Square Payroll alias see a physical card upsell
 * app message after onboarding.
 */
export enum ExperimentsPayrollOnboardingCardUpsellPolicy {
  PAYROLL_ONBOARDING_CARD_UPSELL_DISABLED = "PAYROLL_ONBOARDING_CARD_UPSELL_DISABLED",
  PAYROLL_ONBOARDING_CARD_UPSELL_ENABLED = "PAYROLL_ONBOARDING_CARD_UPSELL_ENABLED",
}

/** Policy to control if customers see a physical card upsell app message after onboarding. */
export enum ExperimentsOnboardingCardUpsellPolicy {
  ONBOARDING_CARD_UPSELL_DISABLED = "ONBOARDING_CARD_UPSELL_DISABLED",
  ONBOARDING_CARD_UPSELL_ENABLED = "ONBOARDING_CARD_UPSELL_ENABLED",
}

/** Whether or not to use Binfo or the star_bins table for Star pull routing. */
export enum ExperimentsUseBinfoForStarPullRouting {
  USE_STAR_BINS_TABLE_FOR_PULL_ROUTING = "USE_STAR_BINS_TABLE_FOR_PULL_ROUTING",
  USE_BINFO_FOR_PULL_ROUTING = "USE_BINFO_FOR_PULL_ROUTING",
}

/** Whether or not customers can activate virtual cards on the web. */
export enum ExperimentsWebActivateCardPolicy {
  /** @deprecated */
  WEB_ACTIVATE_CARD_DISABLED = "WEB_ACTIVATE_CARD_DISABLED",
  /** @deprecated */
  WEB_ACTIVATE_CARD_ENABLED = "WEB_ACTIVATE_CARD_ENABLED",
}

/** How iOS clients should display dialogs. */
export enum ExperimentsIosDialogsPolicy {
  FULLSCREEN_DIALOGS = "FULLSCREEN_DIALOGS",
  FLOATING_MODAL_DIALOGS = "FLOATING_MODAL_DIALOGS",
}

/** Marks a customer as a likely target that requires a stricter login. */
export enum ExperimentsHighValueTargetLoginPolicy {
  HIGH_VALUE_TARGET_LOGIN_DISABLED = "HIGH_VALUE_TARGET_LOGIN_DISABLED",
  HIGH_VALUE_TARGET_LOGIN_ENABLED = "HIGH_VALUE_TARGET_LOGIN_ENABLED",
}

/** Determines what card issuer is used. */
export enum ExperimentsCardIssuerPolicy {
  MARQETA = "MARQETA",
  SHAZAM = "SHAZAM",
  /** @deprecated */
  MARQETA_AND_SHAZAM = "MARQETA_AND_SHAZAM",
  MARQETA_ADMIN = "MARQETA_ADMIN",
  /**
   * SHAZAM_ADMIN - The Admin experiments can force issuing Marqeta/Shazam card regardless of existing card.
   * They should be used only in tester and not in prod as it would break when toggling experiment.
   */
  SHAZAM_ADMIN = "SHAZAM_ADMIN",
}

/** Determines if to use transfers flow for bitcoin exchanges. */
export enum ExperimentsTransferFlowForBtcExchangePolicy {
  TRANSFER_FLOW_DISABLED = "TRANSFER_FLOW_DISABLED",
  TRANSFER_FLOW_ENABLED = "TRANSFER_FLOW_ENABLED",
}

export enum ExperimentsCustomerTokenSource {
  RANDOM = "RANDOM",
  SEQUENCE = "SEQUENCE",
}

/** If enabled, all pull routing is done via Routy. */
export enum ExperimentsPullViaRouty {
  ROUTY_PULL_DISABLED = "ROUTY_PULL_DISABLED",
  ROUTY_PULL_ENABLED = "ROUTY_PULL_ENABLED",
}

/** If enabled, all push routing is done via Routy. */
export enum ExperimentsPushViaRouty {
  ROUTY_PUSH_DISABLED = "ROUTY_PUSH_DISABLED",
  ROUTY_PUSH_ENABLED = "ROUTY_PUSH_ENABLED",
}

export enum ExperimentsBitcoinExecutePurchasePolicy {
  PROCESS_ORDER_AS_EXCHANGE = "PROCESS_ORDER_AS_EXCHANGE",
  USE_ORDER_BOOK = "USE_ORDER_BOOK",
}

/** If allowed, the iOS app will allow customers to change their app icon. */
export enum ExperimentsAllowAppIconChangeIosPolicy {
  DISALLOW_APP_ICON_CHANGE = "DISALLOW_APP_ICON_CHANGE",
  ALLOW_APP_ICON_CHANGE = "ALLOW_APP_ICON_CHANGE",
}

/** As of September 2018 this is exposed as a feature flag to clients. */
export enum ExperimentsAllowBitcoinOperationsPolicy {
  BITCOIN_OPERATIONS_ENABLED = "BITCOIN_OPERATIONS_ENABLED",
  BITCOIN_OPERATIONS_DISABLED = "BITCOIN_OPERATIONS_DISABLED",
}

/** Policy that dictates how we process card events. */
export enum ExperimentsCardEventProcessPolicy {
  SERVER_ONLY = "SERVER_ONLY",
  CUSTOMER_FACING = "CUSTOMER_FACING",
}

export enum ExperimentsCashAdvanceOfferPolicy {
  CASH_ADVANCE_OFFER_DISABLED = "CASH_ADVANCE_OFFER_DISABLED",
  CASH_ADVANCE_OFFER_ENABLED = "CASH_ADVANCE_OFFER_ENABLED",
}

export enum ExperimentsCashCashOutSubCategoryPolicy {
  CASH_CASH_OUT_SUBCATEGORY_DISBALED = "CASH_CASH_OUT_SUBCATEGORY_DISBALED",
  CASH_CASH_OUT_SUBCATEGORY_ENABLED = "CASH_CASH_OUT_SUBCATEGORY_ENABLED",
}

/** Policy to control whether the Auto Cash Out toggle is rendered in Customer Profile. */
export enum ExperimentsAutoCashOutTogglePolicy {
  /** AUTO_CASH_OUT_TOGGLE_SHOWN - Hide Auto Cash Out toggle only from customers without stored balance. */
  AUTO_CASH_OUT_TOGGLE_SHOWN = "AUTO_CASH_OUT_TOGGLE_SHOWN",
  /**
   * AUTO_CASH_OUT_TOGGLE_HIDDEN_FOR_NEW_CUSTOMERS - Hide Auto Cash Out toggle also from customers who have created their accounts after
   * {@code DepositPreferenceDataPopulator.CUSTOMER_REGISTRATION_DATE_TO_START_HIDING_AUTO_CASH_OUT_TOGGLE}
   * and who have Auto Cash Out disabled and not used it recently.
   */
  AUTO_CASH_OUT_TOGGLE_HIDDEN_FOR_NEW_CUSTOMERS = "AUTO_CASH_OUT_TOGGLE_HIDDEN_FOR_NEW_CUSTOMERS",
  /**
   * AUTO_CASH_OUT_TOGGLE_HIDDEN_FOR_ALL_CUSTOMERS - Hide Auto Cash Out toggle also from all customers who have Auto Cash Out disabled and not
   * used it recently.
   */
  AUTO_CASH_OUT_TOGGLE_HIDDEN_FOR_ALL_CUSTOMERS = "AUTO_CASH_OUT_TOGGLE_HIDDEN_FOR_ALL_CUSTOMERS",
}

/** Policy to control whether to include in-app promotions in status results. */
export enum ExperimentsPromoInStatusResultPolicy {
  /** NO_PROMO_IN_STATUS_RESULT - Do not add promotions to status results. */
  NO_PROMO_IN_STATUS_RESULT = "NO_PROMO_IN_STATUS_RESULT",
  /** PROMO_IN_STATUS_RESULT - Include promotions in status results. */
  PROMO_IN_STATUS_RESULT = "PROMO_IN_STATUS_RESULT",
}

/**
 * Policy that controls whether clients should show Cash card controls in settings. As of
 * September 2018 this is exposed as a feature flag to clients.
 */
export enum ExperimentsCashCardControlsInSettingsPolicy {
  CASH_CARD_CONTROLS_IN_SETTINGS_DISABLED = "CASH_CARD_CONTROLS_IN_SETTINGS_DISABLED",
  CASH_CARD_CONTROLS_IN_SETTINGS_ENABLED = "CASH_CARD_CONTROLS_IN_SETTINGS_ENABLED",
}

/** Policy that controls whether the app is going to show usd static limits. */
export enum ExperimentsShowUsdStaticLimitsPolicy {
  SHOW_USD_STATIC_LIMITS_DISBALED = "SHOW_USD_STATIC_LIMITS_DISBALED",
  SHOW_USD_STATIC_LIMITS_ENABLED = "SHOW_USD_STATIC_LIMITS_ENABLED",
}

/** Policy that controls whether the app is going to show bitcoin static limits. */
export enum ExperimentsShowBtcStaticLimitsPolicy {
  SHOW_BTC_STATIC_LIMITS_DISBALED = "SHOW_BTC_STATIC_LIMITS_DISBALED",
  SHOW_BTC_STATIC_LIMITS_ENABLED = "SHOW_BTC_STATIC_LIMITS_ENABLED",
}

/**
 * Policy that controls if Recipient Confirmation blockers are enabled for
 * scenarios where misdirected payments are suspected
 */
export enum ExperimentsMisdirectedPaymentConfirmationPolicy {
  NO_MISDIRECTED_PAYMENT_CONFIRMATION_BLOCKER = "NO_MISDIRECTED_PAYMENT_CONFIRMATION_BLOCKER",
  MISDIRECTED_PAYMENT_RECIPIENT_CONFIRMATION_BLOCKER = "MISDIRECTED_PAYMENT_RECIPIENT_CONFIRMATION_BLOCKER",
  MISDIRECTED_PAYMENT_RECIPIENT_SKIP_FOR_PREVIOUSLY_CONFIRMED =
    "MISDIRECTED_PAYMENT_RECIPIENT_SKIP_FOR_PREVIOUSLY_CONFIRMED",
}

/**
 * Policy that controls if a customer can access bitcoin without having a phone number linked
 * and add it later during the exchange cryptocurrency flow.
 */
export enum ExperimentsBtcPhoneNumberPolicy {
  REQUIRE_PHONE_NUMBER_FOR_ONBOARDING = "REQUIRE_PHONE_NUMBER_FOR_ONBOARDING",
  REQUIRE_PHONE_NUMBER_DURING_TRANSACTIONS = "REQUIRE_PHONE_NUMBER_DURING_TRANSACTIONS",
}

/** Policy that controls whether to enable the new replace card flow */
export enum ExperimentsReplaceLostCardPolicy {
  ORIGINAL_LOST_CARD_FLOW = "ORIGINAL_LOST_CARD_FLOW",
  LOST_CARD_FLOW_V2 = "LOST_CARD_FLOW_V2",
  /**
   * INTERNAL_TESTING_MULTI_CARD - Allows internal cash team members to reissue multiple cards without affecting their current
   * card. No customer should be put in this bucket!
   */
  INTERNAL_TESTING_MULTI_CARD = "INTERNAL_TESTING_MULTI_CARD",
}

/**
 * Whether to activate using the provided card token, or whether to find the correct card
 * using the stored value token
 */
export enum ExperimentsPhysicalCardActivationPolicy {
  ACTIVATE_VIA_STORED_VALUE_TOKEN = "ACTIVATE_VIA_STORED_VALUE_TOKEN",
  ACTIVATE_VIA_CARD_TOKEN = "ACTIVATE_VIA_CARD_TOKEN",
}

/** Policy to control the availability of Square loyalty and Cash integration. */
export enum ExperimentsSquareLoyaltyPolicy {
  SQUARE_LOYALTY_DISABLED = "SQUARE_LOYALTY_DISABLED",
  SQUARE_LOYALTY_ENABLED = "SQUARE_LOYALTY_ENABLED",
}

/** Policy that controls whether we should limit bitcoin withdrawals for a customer. */
export enum ExperimentsLimitBitcoinWithdrawalPolicy {
  LIMIT_BITCOIN_WITHDRAWAL_ENABLED = "LIMIT_BITCOIN_WITHDRAWAL_ENABLED",
  LIMIT_BITCOIN_WITHDRAWAL_DISABLED = "LIMIT_BITCOIN_WITHDRAWAL_DISABLED",
}

/** Control whether Profile is generated in the background and returned in ResponseContext */
export enum ExperimentsProfileInResponseContextPolicy {
  DISABLE_PROFILE_IN_RESPONSE_CONTEXT = "DISABLE_PROFILE_IN_RESPONSE_CONTEXT",
  ENABLE_PROFILE_IN_RESPONSE_CONTEXT = "ENABLE_PROFILE_IN_RESPONSE_CONTEXT",
}

/** Policy that controls whether a Cash customer has the Auto Add Cash feature enabled on web. */
export enum ExperimentsWebAutoAddCashPolicy {
  WEB_AUTO_ADD_CASH_DISABLED = "WEB_AUTO_ADD_CASH_DISABLED",
  WEB_AUTO_ADD_CASH_ENABLED = "WEB_AUTO_ADD_CASH_ENABLED",
}

/** Policy that controls iOS application UI mode.  Supported in 2.24+ */
export enum ExperimentsAppUserInterfacePolicyIos {
  APP_USER_INTERFACE_IOS_LEGACY = "APP_USER_INTERFACE_IOS_LEGACY",
  APP_USER_INTERFACE_IOS_TABBED = "APP_USER_INTERFACE_IOS_TABBED",
}

/** Policy that controls Android application UI mode.  Supported in 2.24+ */
export enum ExperimentsAppUserInterfacePolicyAndroid {
  APP_USER_INTERFACE_ANDROID_LEGACY = "APP_USER_INTERFACE_ANDROID_LEGACY",
  APP_USER_INTERFACE_ANDROID_TABBED = "APP_USER_INTERFACE_ANDROID_TABBED",
}

/**
 * Policy that controls if clients should show a card wiggle to nudge customers towards tapping
 * the card.
 */
export enum ExperimentsCashCardDrawerWiggleAffordancePolicy {
  CASH_CARD_DRAWER_WIGGLE_AFFORDANCE_DISABLED = "CASH_CARD_DRAWER_WIGGLE_AFFORDANCE_DISABLED",
  CASH_CARD_DRAWER_WIGGLE_AFFORDANCE_ENABLED = "CASH_CARD_DRAWER_WIGGLE_AFFORDANCE_ENABLED",
}

/**
 * Control whether Profile is generated in the background and returned in ResponseContext
 * separately for Android and iOS. As of September 2018 this is exposed as a feature flag to
 * clients.
 */
export enum ExperimentsProfileInResponseContextAndroidPolicy {
  DISABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_ANDROID = "DISABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_ANDROID",
  ENABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_ANDROID = "ENABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_ANDROID",
}

/** As of September 2018 this is exposed as a feature flag to clients. */
export enum ExperimentsProfileInResponseContextIosPolicy {
  DISABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_IOS = "DISABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_IOS",
  ENABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_IOS = "ENABLE_PROFILE_IN_RESPONSE_CONTEXT_FOR_IOS",
}

export enum ExperimentsWebRegionSelectionPolicy {
  WEB_REGION_SELECTION_DISABLED = "WEB_REGION_SELECTION_DISABLED",
  WEB_REGION_SELECTION_ENABLED = "WEB_REGION_SELECTION_ENABLED",
}

/**
 * Whether or not the user has the ability to set an auto add cash preference. As of September
 * 2018 this is exposed as a feature flag to clients.
 *
 * This has been deprecated and should not be used. An app store version was released with broken
 * functionality gated only by this flag. As such, we need to leave this flag in the disabled
 * state forever.
 */
export enum ExperimentsAutoAddCashPolicy {
  DISABLE_AUTO_ADD_CASH = "DISABLE_AUTO_ADD_CASH",
  ENABLE_AUTO_ADD_CASH = "ENABLE_AUTO_ADD_CASH",
}

/** Policy that blindly forces Recipient Confirmation blockers on payments */
export enum ExperimentsForcePaymentConfirmationPolicy {
  DISABLE_FORCED_PAYMENT_CONFIRMATION_BLOCKER = "DISABLE_FORCED_PAYMENT_CONFIRMATION_BLOCKER",
  ENABLE_FORCED_PAYMENT_CONFIRMATION_BLOCKER = "ENABLE_FORCED_PAYMENT_CONFIRMATION_BLOCKER",
}

/**
 * Policy to control whether to include card in-app promotions in the status result for an instant
 * cash out.
 */
export enum ExperimentsUpsellCardAfterInstantCashOutPolicy {
  NO_PROMO_FOR_INSTANT = "NO_PROMO_FOR_INSTANT",
  PROMO_FOR_INSTANT = "PROMO_FOR_INSTANT",
}

/**
 * Controls whether or not iOS directly calls sync-entities when the app is foregrounded. iOS
 * should be able to rely on data in the response context, but this will let iOS safely test the
 * removal of the old manual call. As of September 2018 this is exposed as a feature flag to
 * clients.
 */
export enum ExperimentsSyncEntitiesOnForegroundIosPolicy {
  SYNC_ENTITIES_ON_FOREGROUND_IN_IOS_ENABLED = "SYNC_ENTITIES_ON_FOREGROUND_IN_IOS_ENABLED",
  SYNC_ENTITIES_ON_FOREGROUND_IN_IOS_DISABLED = "SYNC_ENTITIES_ON_FOREGROUND_IN_IOS_DISABLED",
}

/**
 * Policy that controls if customer can execute Apple Pay yellow flow. As of September 2018 this
 * is exposed as a feature flag to clients.
 */
export enum ExperimentsApplePayAppToAppVerificationPolicy {
  APPLE_PAY_APP_TO_APP_VERIFICATION_DISABLED = "APPLE_PAY_APP_TO_APP_VERIFICATION_DISABLED",
  APPLE_PAY_APP_TO_APP_VERIFICATION_ENABLED = "APPLE_PAY_APP_TO_APP_VERIFICATION_ENABLED",
}

/**
 * Policy that controls if we want to create sync entities from exchanges or rely on transactions
 * signaled via banklin.
 */
export enum ExperimentsSyncEntitiesForBitcoinExchangesPolicy {
  USE_TRANSACTIONS = "USE_TRANSACTIONS",
  USE_TRANSFERS = "USE_TRANSFERS",
}

/**
 * Policy to determine whether to enable MccPadding.  MccPadding can result in declines with
 * an octopus_result of POTENTIALLY_INSUFFICIENT_FUNDS
 */
export enum ExperimentsMccPadderPolicy {
  ENABLED = "ENABLED",
  DISABLED = "DISABLED",
}

/**
 * Policy to determine which App Review prompt we should use on iOS. As of September 2018 this is
 * exposed as a feature flag to clients.
 */
export enum ExperimentsAppReviewPromptBehaviourPolicy {
  APP_REVIEW_PROMPT_BEHAVIOR_CUSTOM_STORE_REDIRECT = "APP_REVIEW_PROMPT_BEHAVIOR_CUSTOM_STORE_REDIRECT",
  APP_REVIEW_PROMPT_BEHAVIOR_PLATFORM_NATIVE = "APP_REVIEW_PROMPT_BEHAVIOR_PLATFORM_NATIVE",
}

/** Policy to control which gateway name to use for Omnipay pushes in staging. */
export enum ExperimentsOmnipayStagingGatewayPolicy {
  USE_SIMULATOR = "USE_SIMULATOR",
  USE_OMNIPAY = "USE_OMNIPAY",
}

/** (Hack-Week) Policy to control if the app should integrate third party trading. */
export enum ExperimentsThirdPartyTradingPolicy {
  THIRD_PARTY_TRADING_DISABLED = "THIRD_PARTY_TRADING_DISABLED",
  THIRD_PARTY_TRADING_ENABLED = "THIRD_PARTY_TRADING_ENABLED",
}

/** Controls balance checks via Plaid. */
export enum ExperimentsBankbookBalanceChecksPolicy {
  /** PLAID_BALANCE_CHECKS_ON_DEMAND - Balance checks are executed on demand: no scheduled async jobs. */
  PLAID_BALANCE_CHECKS_ON_DEMAND = "PLAID_BALANCE_CHECKS_ON_DEMAND",
  /** PLAID_BALANCE_CHECKS_SHEDDING - If there are any accumulated balance check tasks in queue, they will be cancelled. */
  PLAID_BALANCE_CHECKS_SHEDDING = "PLAID_BALANCE_CHECKS_SHEDDING",
}

/**
 * Policy to decide which MCC to use for UK Pulls
 * For this to be enabled, the payment needs to be in the UK and pull from a specific set of BINs
 */
export enum ExperimentsUkUseMiscMccPolicy {
  UK_MISC_MCC_DISABLED = "UK_MISC_MCC_DISABLED",
  UK_MISC_MCC_ENABLED = "UK_MISC_MCC_ENABLED",
}

/** Policy to control the switch over to CloudContacts */
export enum ExperimentsCloudContactsPolicy {
  CLOUD_CONTACTS_DISABLED = "CLOUD_CONTACTS_DISABLED",
  CLOUD_CONTACTS_SHADOW_WRITE = "CLOUD_CONTACTS_SHADOW_WRITE",
  CLOUD_CONTACTS_SHADOW_READ_WRITE = "CLOUD_CONTACTS_SHADOW_READ_WRITE",
  CLOUD_CONTACTS_ENABLED = "CLOUD_CONTACTS_ENABLED",
}

/** Controls the availability of the referral program in GBR. */
export enum ExperimentsReferralProgramGbrPolicy {
  GBR_REFERRAL_PROGRAM_DISABLED = "GBR_REFERRAL_PROGRAM_DISABLED",
  GBR_REFERRAL_PROGRAM_ENABLED = "GBR_REFERRAL_PROGRAM_ENABLED",
}

/**
 * Manages the active reward code programs available to GBR customers.
 * For the US, refer to RewardCodeProgramDisplayPolicy.
 */
export enum ExperimentsRewardCodeProgramDisplayGbrPolicy {
  FIVE_BY_FIVE_GBR = "FIVE_BY_FIVE_GBR",
  TEN_BY_TEN_GBR = "TEN_BY_TEN_GBR",
  TEN_BY_TEN_REPLICATING_1_GBR = "TEN_BY_TEN_REPLICATING_1_GBR",
  TEN_BY_TEN_REPLICATING_2_GBR = "TEN_BY_TEN_REPLICATING_2_GBR",
  TEN_BY_TEN_REPLICATING_3_GBR = "TEN_BY_TEN_REPLICATING_3_GBR",
  TEN_BY_TEN_REPLICATING_4_GBR = "TEN_BY_TEN_REPLICATING_4_GBR",
  TEN_BY_TEN_REPLICATING_5_GBR = "TEN_BY_TEN_REPLICATING_5_GBR",
  TEN_BY_TEN_REPLICATING_6_GBR = "TEN_BY_TEN_REPLICATING_6_GBR",
  TEN_BY_TEN_REPLICATING_7_GBR = "TEN_BY_TEN_REPLICATING_7_GBR",
  TEN_BY_TEN_REPLICATING_8_GBR = "TEN_BY_TEN_REPLICATING_8_GBR",
  TEN_BY_TEN_REPLICATING_9_GBR = "TEN_BY_TEN_REPLICATING_9_GBR",
  TEN_BY_TEN_REPLICATING_10_GBR = "TEN_BY_TEN_REPLICATING_10_GBR",
  TEN_BY_TEN_REPLICATING_11_GBR = "TEN_BY_TEN_REPLICATING_11_GBR",
  TEN_BY_TEN_REPLICATING_12_GBR = "TEN_BY_TEN_REPLICATING_12_GBR",
  TEN_BY_TEN_REPLICATING_13_GBR = "TEN_BY_TEN_REPLICATING_13_GBR",
  TEN_BY_TEN_REPLICATING_14_GBR = "TEN_BY_TEN_REPLICATING_14_GBR",
  TEN_BY_TEN_REPLICATING_15_GBR = "TEN_BY_TEN_REPLICATING_15_GBR",
}

/** Policy to control whether iOS clients will send referral emails directly or through the server. */
export enum ExperimentsNativeReferralEmailsIosPolicy {
  NATIVE_REFERRAL_EMAILS_DISABLED_FOR_IOS = "NATIVE_REFERRAL_EMAILS_DISABLED_FOR_IOS",
  NATIVE_REFERRAL_EMAILS_ENABLED_FOR_IOS = "NATIVE_REFERRAL_EMAILS_ENABLED_FOR_IOS",
}

/**
 * Policy to control whether Android clients will send referral emails directly
 * or through the server.
 */
export enum ExperimentsNativeReferralEmailsAndroidPolicy {
  NATIVE_REFERRAL_EMAILS_DISABLED_FOR_ANDROID = "NATIVE_REFERRAL_EMAILS_DISABLED_FOR_ANDROID",
  NATIVE_REFERRAL_EMAILS_ENABLED_FOR_ANDROID = "NATIVE_REFERRAL_EMAILS_ENABLED_FOR_ANDROID",
}

/**
 * Policy to control if a customer can specify a custom cash out amount from the drawer. As of
 * September 2018 this is exposed as a feature flag to clients.
 */
export enum ExperimentsCashOutDrawerBehaviorPolicy {
  CASH_OUT_DRAWER_BEHAVIOR_FULL_AMOUNT = "CASH_OUT_DRAWER_BEHAVIOR_FULL_AMOUNT",
  CASH_OUT_DRAWER_BEHAVIOR_CUSTOM_AMOUNT = "CASH_OUT_DRAWER_BEHAVIOR_CUSTOM_AMOUNT",
}

/**
 * Policy to control initial slider position for custom cash outs. As of September 2018 this is
 * exposed as a feature flag to clients.
 */
export enum ExperimentsCashOutSliderInitialValuePolicy {
  CASH_OUT_SLIDER_INITIAL_VALUE_MINIMUM = "CASH_OUT_SLIDER_INITIAL_VALUE_MINIMUM",
  CASH_OUT_SLIDER_INITIAL_VALUE_MAXIMUM = "CASH_OUT_SLIDER_INITIAL_VALUE_MAXIMUM",
}

/** Policy to control whether to include in-app promotions for card activation. */
export enum ExperimentsUpsellCardActivationPolicy {
  ACTIVATION_PROMO_DISABLED = "ACTIVATION_PROMO_DISABLED",
  ACTIVATION_PROMO_ENABLED = "ACTIVATION_PROMO_ENABLED",
}

/**
 * Policy to control the preference for recipient alias selection. As of September 2018 this is
 * exposed as a feature flag to clients.
 */
export enum ExperimentsRecipientChooserAliasPreferenceIosPolicy {
  RECIPIENT_CHOOSER_ALIAS_PREFERENCE_STANDARD = "RECIPIENT_CHOOSER_ALIAS_PREFERENCE_STANDARD",
  RECIPIENT_CHOOSER_ALIAS_PREFERENCE_SUPPRESS_EMAIL = "RECIPIENT_CHOOSER_ALIAS_PREFERENCE_SUPPRESS_EMAIL",
}

/**
 * Used as an override to determine special Square customers able to do ACH pulls without
 * conforming to the main business rules (see AchPullsInUsPolicy).
 */
export enum ExperimentsAchPullsSpecialCustomersOverride {
  ACH_PULLS_SPECIAL_CUSTOMER_DISABLED = "ACH_PULLS_SPECIAL_CUSTOMER_DISABLED",
  ACH_PULLS_SPECIAL_CUSTOMER_ENABLED = "ACH_PULLS_SPECIAL_CUSTOMER_ENABLED",
}

/**
 * Policy to control business rules for ACH pulls. For more details, see the design doc:
 * https://docs.google.com/document/d/1fdtCrSP2N9WYHs2nYYA1iDxIvClZ2pukybCnOih2Tmk/edit
 */
export enum ExperimentsAchPullsInUsPolicy {
  ACH_PULLS_IN_US_DISABLED = "ACH_PULLS_IN_US_DISABLED",
  ACH_PULLS_IN_US_ENABLED_FOR_ELIGIBLE_MC_PULLS = "ACH_PULLS_IN_US_ENABLED_FOR_ELIGIBLE_MC_PULLS",
  /** ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_PULLS - Special override for testing using any debit card. */
  ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_PULLS = "ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_PULLS",
  /** ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_SKIPPING_BANK_CHECK - Special override for testing using any debit card and ignoring bank mismatch. */
  ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_SKIPPING_BANK_CHECK =
    "ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_SKIPPING_BANK_CHECK",
  /** ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_SKIPPING_RISK_CHECK - Special override for testing using any debit card and skipping risk check. */
  ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_SKIPPING_RISK_CHECK =
    "ACH_PULLS_IN_US_ENABLED_FOR_ALL_DEBIT_SKIPPING_RISK_CHECK",
  /** ACH_PULLS_IN_US_ENABLED_WITHOUT_DEBIT - Enables ACH pulls without fallback to debit cards. This still does not allow ACH pulls if customer has Visa card linked. */
  ACH_PULLS_IN_US_ENABLED_WITHOUT_DEBIT = "ACH_PULLS_IN_US_ENABLED_WITHOUT_DEBIT",
  /** ACH_PULLS_IN_US_ENABLED_SKIPPING_VISA_CHECK - Special override for testing ACH without debit ignoring Visa card restriction. */
  ACH_PULLS_IN_US_ENABLED_SKIPPING_VISA_CHECK = "ACH_PULLS_IN_US_ENABLED_SKIPPING_VISA_CHECK",
}

/**
 * Policy to control whether we want to display the slow bitcoin withdrawal confirmation screen
 * during transferring cryptocurrency
 */
export enum ExperimentsSlowBitcoinWithdrawalPolicy {
  SLOW_WITHDRAWALS_DISABLED = "SLOW_WITHDRAWALS_DISABLED",
  SLOW_WITHDRAWALS_ENABLED = "SLOW_WITHDRAWALS_ENABLED",
}

/** Policy to control how Banklin routes push requests. */
export enum ExperimentsBanklinPushRoutingPolicy {
  PUSH_USING_ROUTER = "PUSH_USING_ROUTER",
  PUSH_DIRECT_TO_LEDGER = "PUSH_DIRECT_TO_LEDGER",
}

/** Policy to control how Banklin routes pull requests. */
export enum ExperimentsBanklinPullRoutingPolicy {
  PULL_USING_ROUTER = "PULL_USING_ROUTER",
  PULL_DIRECT_FROM_LEDGER = "PULL_DIRECT_FROM_LEDGER",
}

/** If we should use the itemized selection blocker in the exchange cryptocurrency flow. */
export enum ExperimentsItemizedSelectionBlockerPolicy {
  ITEMIZED_SELECTION_BLOCKER_DISABLED = "ITEMIZED_SELECTION_BLOCKER_DISABLED",
  ITEMIZED_SELECTION_BLOCKER_ENABLED = "ITEMIZED_SELECTION_BLOCKER_ENABLED",
}

/** Policy that presents a waitlist selection blocker for users in waitlist-enabled regions. */
export enum ExperimentsOnboardingWaitlistPolicy {
  WAITLIST_DISABLED = "WAITLIST_DISABLED",
  WAITLIST_ENABLED_FOR_GB = "WAITLIST_ENABLED_FOR_GB",
}

/**
 * Policy that controls whether a Cash customer will be able to interact with Boost regardless
 * of whether they have an issued card or if their card state is completely 'healthy'.
 */
export enum ExperimentsBoostForAllPolicy {
  BOOST_FOR_ALL_DISABLED = "BOOST_FOR_ALL_DISABLED",
  BOOST_FOR_ALL_ENABLED = "BOOST_FOR_ALL_ENABLED",
}

/** Policy to control whether to include social in-app promotions in status results. */
export enum ExperimentsUpsellSocialPolicy {
  NO_PROMO_FOR_SOCIAL = "NO_PROMO_FOR_SOCIAL",
  PROMO_FOR_SOCIAL = "PROMO_FOR_SOCIAL",
}

/** Policy to control whether or not we pass ACH blockers in the auto add cash flow. */
export enum ExperimentsAutoAddCashAchPolicy {
  AUTO_ADD_CASH_ACH_DISABLED = "AUTO_ADD_CASH_ACH_DISABLED",
  AUTO_ADD_CASH_ACH_ENABLED = "AUTO_ADD_CASH_ACH_ENABLED",
}

/**
 * Policy to control whether or not to withdraw from BTC balance when making purchases
 * via cash card.
 */
export enum ExperimentsCashCardBtcPolicy {
  DONT_WITHDRAW_FROM_BTC = "DONT_WITHDRAW_FROM_BTC",
  WITHDRAW_FROM_BTC = "WITHDRAW_FROM_BTC",
}

/**
 * Policy that controls whether an iOS Cash customer will be able to interact with Boost
 * regardless of whether they have an issued card or if their card state is completely 'healthy'.
 * As of September 2018 this is exposed as a feature flag to clients.
 */
export enum ExperimentsBoostForAllIosPolicy {
  BOOST_FOR_ALL_IOS_DISABLED = "BOOST_FOR_ALL_IOS_DISABLED",
  /** @deprecated */
  BOOST_FOR_ALL_IOS_2_33_PLUS_ENABLED = "BOOST_FOR_ALL_IOS_2_33_PLUS_ENABLED",
  /** BOOST_FOR_ALL_IOS_2_34_PLUS_ENABLED - Next tag = 5. */
  BOOST_FOR_ALL_IOS_2_34_PLUS_ENABLED = "BOOST_FOR_ALL_IOS_2_34_PLUS_ENABLED",
}

/**
 * Policy that controls whether an Android Cash customer will be able to interact with Boost
 * regardless of whether they have an issued card or if their card state is completely 'healthy'.
 * As of September 2018 this is exposed as a feature flag to clients.
 */
export enum ExperimentsBoostForAllAndroidPolicy {
  BOOST_FOR_ALL_ANDROID_DISABLED = "BOOST_FOR_ALL_ANDROID_DISABLED",
  /** @deprecated */
  BOOST_FOR_ALL_ANDROID_ENABLED = "BOOST_FOR_ALL_ANDROID_ENABLED",
  /** @deprecated */
  BOOST_FOR_ALL_ANDROID_2_32_PLUS_ENABLED = "BOOST_FOR_ALL_ANDROID_2_32_PLUS_ENABLED",
  /** @deprecated */
  BOOST_FOR_ALL_ANDROID_2_33_PLUS_ENABLED = "BOOST_FOR_ALL_ANDROID_2_33_PLUS_ENABLED",
  BOOST_FOR_ALL_ANDROID_2_34_PLUS_ENABLED = "BOOST_FOR_ALL_ANDROID_2_34_PLUS_ENABLED",
}

/**
 * Policy that controls whether updating the address of cash card customers in Banklin
 * is deferred using a Jobsy job.
 */
export enum ExperimentsDeferAddressUpdateInBanklinPolicy {
  DEFER_ADDRESS_UPDATE_IN_BANKLIN_DISABLED = "DEFER_ADDRESS_UPDATE_IN_BANKLIN_DISABLED",
  DEFER_ADDRESS_UPDATE_IN_BANKLIN_ENABLED = "DEFER_ADDRESS_UPDATE_IN_BANKLIN_ENABLED",
}

/**
 * Policy that dictates if we send notifications for card delivery.
 * Temporary: Customers have been seeing delivered notifications up to a week before the card
 * actually arrived. While we investigate the cause, need ability to turn off these specific
 * notifications.
 */
export enum ExperimentsCardDeliveredNotificationPolicy {
  DO_NOT_NOTIFY_OF_DELIVERED = "DO_NOT_NOTIFY_OF_DELIVERED",
  NOTIFY_OF_DELIVERED = "NOTIFY_OF_DELIVERED",
}

/** Policy to control copies related to the Boost selection screen. */
export enum ExperimentsBoostSelectionScreenCopyPolicy {
  COPY_SET_1 = "COPY_SET_1",
  COPY_SET_2 = "COPY_SET_2",
}

/**
 * Policy to control whether or not display a floating modal in iOS app if a customer is leaving
 * the Boost selection screen without ever selecting a Boost.
 */
export enum ExperimentsNoSelectedBoostModalIosPolicy {
  NO_BOOST_SELECTED_MODAL_IOS_DISABLED = "NO_BOOST_SELECTED_MODAL_IOS_DISABLED",
  NO_BOOST_SELECTED_MODAL_IOS_ENABLED = "NO_BOOST_SELECTED_MODAL_IOS_ENABLED",
}

/**
 * Policy to control whether or not display a floating modal in Android app if a customer is
 * leaving the Boost selection screen without ever selecting a Boost.
 */
export enum ExperimentsNoSelectedBoostModalAndroidPolicy {
  NO_BOOST_SELECTED_MODAL_ANDROID_DISABLED = "NO_BOOST_SELECTED_MODAL_ANDROID_DISABLED",
  NO_BOOST_SELECTED_MODAL_ANDROID_ENABLED = "NO_BOOST_SELECTED_MODAL_ANDROID_ENABLED",
}

/** Onboarding referral code policy for GB. */
export enum ExperimentsOnboardingReferralCodeGbPolicy {
  SHOW_DURING_ONBOARDING_GB = "SHOW_DURING_ONBOARDING_GB",
  DO_NOT_SHOW_DURING_ONBOARDING_GB = "DO_NOT_SHOW_DURING_ONBOARDING_GB",
  SHOW_DURING_ONBOARDING_WITHOUT_PREFILL_GB = "SHOW_DURING_ONBOARDING_WITHOUT_PREFILL_GB",
}

/**
 * Policy to control whether or not to enable the last_push_failed_at column
 * for instrument links.
 */
export enum ExperimentsLastPushInstrumentLinkPolicy {
  LAST_PUSH_INSTRUMENT_LINK_DISABLED = "LAST_PUSH_INSTRUMENT_LINK_DISABLED",
  LAST_PUSH_INSTRUMENT_LINK_ENABLED = "LAST_PUSH_INSTRUMENT_LINK_ENABLED",
}

/** Policy to control whether we render the support button in emails */
export enum ExperimentsEmailContactSupportButtonPolicy {
  EMAIL_CONTACT_SUPPORT_DISABLED = "EMAIL_CONTACT_SUPPORT_DISABLED",
  EMAIL_CONTACT_SUPPORT_ENABLED = "EMAIL_CONTACT_SUPPORT_ENABLED",
}

/** Policy to control if cashboard payments require a past successful payment or not. */
export enum ExperimentsCashboardRequirePastHistoryPolicy {
  PAST_HISTORY_NOT_REQUIRED = "PAST_HISTORY_NOT_REQUIRED",
  PAST_HISTORY_REQUIRED = "PAST_HISTORY_REQUIRED",
}

/** Policy to control whether instruments can be linked in cashboard or not. */
export enum ExperimentsCashboardDisableInstrumentLinkingPolicy {
  INSTRUMENT_LINKING_ENABLED = "INSTRUMENT_LINKING_ENABLED",
  INSTRUMENT_LINKING_DISABLED = "INSTRUMENT_LINKING_DISABLED",
}

/** Policy to control whether we track analytics for emails. */
export enum ExperimentsEmailPromotionAnalyticsPolicy {
  EMAIL_PROMOTION_ANALYTICS_DISABLED = "EMAIL_PROMOTION_ANALYTICS_DISABLED",
  EMAIL_PROMOTION_ANALYTICS_ENABLED = "EMAIL_PROMOTION_ANALYTICS_ENABLED",
}

/** Policy for how boosts are journaled on DDA accounts. */
export enum ExperimentsJournalBoostsPolicy {
  JOURNAL_BOOSTS_SEPARATELY_DISABLED = "JOURNAL_BOOSTS_SEPARATELY_DISABLED",
  JOURNAL_BOOSTS_SEPARATELY_ENABLED = "JOURNAL_BOOSTS_SEPARATELY_ENABLED",
}

/** Policy to control whether to add card customization to the onboarding flow. */
export enum ExperimentsChangeCardDesignPolicy {
  CHANGE_CARD_DESIGN_DISABLED = "CHANGE_CARD_DESIGN_DISABLED",
  CHANGE_CARD_DESIGN_ENABLED = "CHANGE_CARD_DESIGN_ENABLED",
}

/** Policy for which bitcoin wallet to make withdrawals from. */
export enum ExperimentsBitcoinWalletBackendTypePolicy {
  BITCOINJ_WALLET = "BITCOINJ_WALLET",
  BITGO_WALLET = "BITGO_WALLET",
}

/** Policy to control the instrument used to process refunds to the sender. */
export enum ExperimentsPaymentRefundPolicy {
  REFUND_INTO_ORIGINATING_INSTRUMENT = "REFUND_INTO_ORIGINATING_INSTRUMENT",
  REFUND_INTO_CASH_BALANCE = "REFUND_INTO_CASH_BALANCE",
}

/** Policy to control if relinking bank accounts via Plaid 2.0 is enabled. */
export enum ExperimentsPlaidRelinkPolicy {
  PLAID_RELINK_DISABLED = "PLAID_RELINK_DISABLED",
  PLAID_RELINK_ENABLED = "PLAID_RELINK_ENABLED",
}

/** IDV auto fail policy for GB. */
export enum ExperimentsIdvAutoFailGbPolicy {
  IDV_AUTO_FAIL_GB_DISABLED = "IDV_AUTO_FAIL_GB_DISABLED",
  IDV_AUTO_FAIL_GB_FOR_COMPLETELY_DIFFERENT_IDENTITIES = "IDV_AUTO_FAIL_GB_FOR_COMPLETELY_DIFFERENT_IDENTITIES",
}

/**
 * Policy for whether or not to allow customer suspensions.
 * Removing next week.
 */
export enum ExperimentsCustomerSuspensionPolicy {
  CUSTOMER_SUSPENSION_DISABLED = "CUSTOMER_SUSPENSION_DISABLED",
  CUSTOMER_SUSPENSION_ENABLED = "CUSTOMER_SUSPENSION_ENABLED",
}

/**
 * Gates whether a support text option is presented, subject to other constraints.
 * Tags are ordered by smallest to largest group of customers having access to the option.
 */
export enum ExperimentsSupportTextPolicy {
  TEXT_DISABLED_NO_OVERRIDES = "TEXT_DISABLED_NO_OVERRIDES",
  TEXT_DISABLED = "TEXT_DISABLED",
  TEXT_ENABLED_FOR_CAVIAR_COURIER_CUSTOMERS = "TEXT_ENABLED_FOR_CAVIAR_COURIER_CUSTOMERS",
  TEXT_ENABLED_FOR_DIRECT_DEPOSIT_30_DAY_CUSTOMERS = "TEXT_ENABLED_FOR_DIRECT_DEPOSIT_30_DAY_CUSTOMERS",
  TEXT_ENABLED_FOR_DIRECT_DEPOSIT_CUSTOMERS = "TEXT_ENABLED_FOR_DIRECT_DEPOSIT_CUSTOMERS",
  TEXT_ENABLED_FOR_CARD_CUSTOMERS = "TEXT_ENABLED_FOR_CARD_CUSTOMERS",
  TEXT_ENABLED_FOR_ALL_CARD_CUSTOMERS = "TEXT_ENABLED_FOR_ALL_CARD_CUSTOMERS",
  /** TEXT_ENABLED - Tags are out of order. Next tag 9; */
  TEXT_ENABLED = "TEXT_ENABLED",
}

/** Policy for whether or not to use the new colorized avatar rendering endpoint. */
export enum ExperimentsMerchantColorizedAvatarPolicy {
  COLORIZED_AVATARS_DISABLED = "COLORIZED_AVATARS_DISABLED",
  COLORIZED_AVATARS_ENABLED = "COLORIZED_AVATARS_ENABLED",
}

/** Policy for whether or not to display deflection messages. */
export enum ExperimentsSupportDeflectionPolicy {
  DEFLECTION_SHOWN = "DEFLECTION_SHOWN",
  DEFLECTION_NOT_SHOWN = "DEFLECTION_NOT_SHOWN",
}

/**
 * Allow contact support from all support tree nodes.
 *  ENABLED_WHEN_SET - only display if enabled on on the node
 *  ENABLED_FOR_ALL - enable all nodes for the customer
 */
export enum ExperimentsSupportContactEnabledPolicy {
  ENABLED_WHEN_SET = "ENABLED_WHEN_SET",
  ENABLED_FOR_ALL = "ENABLED_FOR_ALL",
}

/** Policy for forcing risk evaluation to return true. Useful for testing individual customers. */
export enum ExperimentsFakeRiskLoginDecisionPolicy {
  USE_REAL_RISK = "USE_REAL_RISK",
  FAKE_RISK_RETURNS_RISKY = "FAKE_RISK_RETURNS_RISKY",
  FAKE_RISK_RETURNS_SAFE = "FAKE_RISK_RETURNS_SAFE",
}

/** Policy for sync entity processing isolation. */
export enum ExperimentsSyncEntityProcessingIsolationPolicy {
  OPTIMISTIC = "OPTIMISTIC",
  SERIALIZED_USING_DATABASE_LOCK = "SERIALIZED_USING_DATABASE_LOCK",
}

/**
 * Policy to control whether a customer's support cases will be created using heuristic
 * prioritization or a machine learning model-based priority score.
 */
export enum ExperimentsMachineLearningCasePrioritizationPolicy {
  USE_HEURISTIC_CASE_PRIORITIZATION = "USE_HEURISTIC_CASE_PRIORITIZATION",
  USE_MACHINE_LEARNING_CASE_PRIORITIZATION = "USE_MACHINE_LEARNING_CASE_PRIORITIZATION",
}

export enum ExperimentsRegisterSmsAppCallbackTokenPolicy {
  DISABLE_REGISTER_SMS_APP_CALLBACK_TOKEN = "DISABLE_REGISTER_SMS_APP_CALLBACK_TOKEN",
  ENABLE_REGISTER_SMS_APP_CALLBACK_TOKEN = "ENABLE_REGISTER_SMS_APP_CALLBACK_TOKEN",
}

/** Policy to control whether we require the full address from customers residing in Florida. */
export enum ExperimentsFloridaAddressBlockerPolicy {
  DONT_REQUIRE_FULL_ADDRESS_FOR_FLORIDA = "DONT_REQUIRE_FULL_ADDRESS_FOR_FLORIDA",
  REQUIRE_FULL_ADDRESS_FOR_FLORIDA = "REQUIRE_FULL_ADDRESS_FOR_FLORIDA",
}

/** Policy dictating which Blocker ordering to use. */
export enum ExperimentsBlockerOrderingPolicy {
  BLOCKER_ORDERING_OLD = "BLOCKER_ORDERING_OLD",
  BLOCKER_ORDERING_NEW = "BLOCKER_ORDERING_NEW",
}

/**
 * An iOS feature flag to control whether the redacted issued card from a profile response
 * should be saved in the client.
 */
export enum ExperimentsUpdateIssuedCardFromProfileIosPolicy {
  UPDATE_ISSUED_CARD_FROM_PROFILE_ENABLED = "UPDATE_ISSUED_CARD_FROM_PROFILE_ENABLED",
  UPDATE_ISSUED_CARD_FROM_PROFILE_DISABLE = "UPDATE_ISSUED_CARD_FROM_PROFILE_DISABLE",
  UPDATE_ISSUED_CARD_FROM_PROFILE_DISABLED = "UPDATE_ISSUED_CARD_FROM_PROFILE_DISABLED",
}

export enum ExperimentsBitcoinW9AgreementPolicy {
  OLD_AGREEMENT_SAVE_DISABLED = "OLD_AGREEMENT_SAVE_DISABLED",
  NEW_AGREEMENT_SAVE_ENABLED = "NEW_AGREEMENT_SAVE_ENABLED",
}

/** Policy to control whether we use the Receipt Promotions tool. */
export enum ExperimentsReceiptPromotionsReferralsPolicy {
  RECEIPT_PROMOTION_REFERRALS_DISABLED = "RECEIPT_PROMOTION_REFERRALS_DISABLED",
  RECEIPT_PROMOTION_REFERRALS_ENABLED = "RECEIPT_PROMOTION_REFERRALS_ENABLED",
}

/** Policy to control if linking bank accounts via Plaid 2.0 or Yodlee is enabled. */
export enum ExperimentsBankAccountLinkingPolicy {
  DEFAULT_LINKING = "DEFAULT_LINKING",
  PLAID_2_ENABLED = "PLAID_2_ENABLED",
}

/**
 * Policy to control whether significant or 'heavy' actions should require an email
 * and phone number in order to be completed, and whether completing these actions makes
 * the customer 'heavy'.
 */
export enum ExperimentsHeavyCustomersPolicy {
  HEAVY_CUSTOMERS_DISABLED = "HEAVY_CUSTOMERS_DISABLED",
  HEAVY_CUSTOMERS_ENABLED = "HEAVY_CUSTOMERS_ENABLED",
}

/** Policy to control including a skip help item in enhanced verification selection blockers. */
export enum ExperimentsSkipEnhancedVerificationBlockersPolicy {
  SKIP_DISABLED = "SKIP_DISABLED",
  SKIP_ENABLED_ALWAYS = "SKIP_ENABLED_ALWAYS",
}

export enum ExperimentsPhysicalCardSignatureApprovalPolicy {
  DO_NOT_AUTO_APPROVE = "DO_NOT_AUTO_APPROVE",
  AUTO_APPROVE_EMPTY_SIGNATURES = "AUTO_APPROVE_EMPTY_SIGNATURES",
  AUTO_APPROVE_FEW_STAMPS = "AUTO_APPROVE_FEW_STAMPS",
}

/**
 * Policy to control whether a customer is in the Boost for Some experiment using iOS. Boost for
 * Some restricts access to the Boost picker screen only after a Cash Card has been requested.
 */
export enum ExperimentsBoostForSomeIosPolicy {
  BOOST_FOR_SOME_IOS_DISABLED = "BOOST_FOR_SOME_IOS_DISABLED",
  BOOST_FOR_SOME_IOS_2_41_PLUS_ENABLED = "BOOST_FOR_SOME_IOS_2_41_PLUS_ENABLED",
}

/**
 * Policy to control whether a customer is in the Boost for Some experiment using Android. Boost
 * for Some restricts access to the Boost picker screen only after a Cash Card has been
 * requested.
 */
export enum ExperimentsBoostForSomeAndroidPolicy {
  BOOST_FOR_SOME_ANDROID_DISABLED = "BOOST_FOR_SOME_ANDROID_DISABLED",
  BOOST_FOR_SOME_ANDROID_2_41_PLUS_ENABLED = "BOOST_FOR_SOME_ANDROID_2_41_PLUS_ENABLED",
}

/**
 * Policy to control whether referral reward payments are paid out when funding from
 * a stored balance.
 */
export enum ExperimentsValidReferralRewardFundingInstrumentPolicy {
  /** @deprecated */
  STORED_BALANCE_IS_VALID = "STORED_BALANCE_IS_VALID",
  /** @deprecated */
  STORED_BALANCE_IS_NOT_VALID = "STORED_BALANCE_IS_NOT_VALID",
}

/**
 * Policy to control whether or not we should upsell Boost exploration if a customer successfully
 * requests for a physical card.
 */
export enum ExperimentsUpsellBoostExplorationPolicy {
  UPSELL_BOOST_EXPLORATION_DISABLED = "UPSELL_BOOST_EXPLORATION_DISABLED",
  UPSELL_BOOST_EXPLORATION_ENABLED = "UPSELL_BOOST_EXPLORATION_ENABLED",
}

/** Policy to control including a button that links to digital wallets for Shazam users. */
export enum ExperimentsShazamDigitalWalletProvisioningPolicy {
  DIGITAL_WALLET_BUTTON_DISABLED = "DIGITAL_WALLET_BUTTON_DISABLED",
  DIGITAL_WALLET_BUTTON_ENABLED = "DIGITAL_WALLET_BUTTON_ENABLED",
}

/** Policy to control whether the W9 should be stored in Franklin. */
export enum ExperimentsBitcoinW9StorePolicy {
  STORE_IN_FRANKLIN_ENABLED = "STORE_IN_FRANKLIN_ENABLED",
  STORE_IN_FRANKLIN_DISABLED = "STORE_IN_FRANKLIN_DISABLED",
}

/** Policy to control whether the W9 should be sent to Taxman. */
export enum ExperimentsBitcoinW9SendToTaxmanPolicy {
  SEND_TO_TAXMAN_DISABLED = "SEND_TO_TAXMAN_DISABLED",
  SEND_TO_TAXMAN_ENABLED = "SEND_TO_TAXMAN_ENABLED",
}

/**
 * Policy to control if the /payments/ page should show a flow to accept payments/requests,
 * or if it should only render a receipt.
 */
export enum ExperimentsPaymentsPageFlowPolicy {
  PAYMENTS_PAGE_FLOW = "PAYMENTS_PAGE_FLOW",
  PAYMENTS_PAGE_RECEIPT_ONLY = "PAYMENTS_PAGE_RECEIPT_ONLY",
}

/** Policy to control linking to enhanced verification from payment receipts. */
export enum ExperimentsPaymentReceiptEnhancedVerificationPolicy {
  DO_NOT_LINK_TO_ENHANCED_VERIFICATION = "DO_NOT_LINK_TO_ENHANCED_VERIFICATION",
  LINK_TO_ENHANCED_VERIFICATION = "LINK_TO_ENHANCED_VERIFICATION",
}

/** Policy to control if we send autoresponses related to autoblocks based off an ML model. */
export enum ExperimentsEnableAutoresponderAutoblockPolicy {
  DO_NOT_SEND_AUTOBLOCK_AUTORESPONSE = "DO_NOT_SEND_AUTOBLOCK_AUTORESPONSE",
  SEND_AUTOBLOCK_AUTORESPONSE = "SEND_AUTOBLOCK_AUTORESPONSE",
}

/** Policy to control whether the 1099B should be sent to Taxman. */
export enum ExperimentsBitcoin1099bSendToTaxmanPolicy {
  SEND_1099B_TO_TAXMAN_DISABLED = "SEND_1099B_TO_TAXMAN_DISABLED",
  SEND_1099B_TO_TAXMAN_ENABLED = "SEND_1099B_TO_TAXMAN_ENABLED",
}

/** Policy to control if transfers get blocked on suspension. */
export enum ExperimentsSuspensionBlockTransfersPolicy {
  DO_NOT_BLOCK_TRANSFERS = "DO_NOT_BLOCK_TRANSFERS",
  BLOCK_CASH_INS = "BLOCK_CASH_INS",
}

/** Policy to control if a customer should be evaluated for local boost. */
export enum ExperimentsEvaluateGeoLocationPolicy {
  EVALUATE_GEO_LOCATION_DISABLED = "EVALUATE_GEO_LOCATION_DISABLED",
  EVALUATE_GEO_LOCATION_ENABLED = "EVALUATE_GEO_LOCATION_ENABLED",
}

export enum ExperimentsIosScrollingQuickAccessBarPolicy {
  IOS_SCROLLING_QUICK_ACCESS_BAR_DISABLED = "IOS_SCROLLING_QUICK_ACCESS_BAR_DISABLED",
  IOS_SCROLLING_QUICK_ACCESS_BAR_ENABLED = "IOS_SCROLLING_QUICK_ACCESS_BAR_ENABLED",
}

/** Policy to control the instrument used to process refunds to the sender (GB). */
export enum ExperimentsGbPaymentRefundPolicy {
  GB_REFUND_INTO_ORIGINATING_INSTRUMENT = "GB_REFUND_INTO_ORIGINATING_INSTRUMENT",
  GB_REFUND_INTO_CASH_BALANCE = "GB_REFUND_INTO_CASH_BALANCE",
}

/**
 * Policy to control whether or not a customer should resync entities when their sync token
 * revision is less than the server revision.
 */
export enum ExperimentsResyncEntitiesRevisionPolicy {
  DO_NOT_RESYNC_ENTITIES = "DO_NOT_RESYNC_ENTITIES",
  RESYNC_ENTITIES = "RESYNC_ENTITIES",
}

export enum ExperimentsOverrideCashInRateLimitPolicy {
  OVERRIDE_CASH_IN_RATE_LIMIT_DISABLED = "OVERRIDE_CASH_IN_RATE_LIMIT_DISABLED",
  OVERRIDE_CASH_IN_RATE_LIMIT_ENABLED = "OVERRIDE_CASH_IN_RATE_LIMIT_ENABLED",
}

/** Controls the soft descriptor prefix and default descriptor for cash-ins (card pulls) only. */
export enum ExperimentsUkSoftDescriptorPrefixPolicy {
  USE_SQC_STAR_SQUARE_CASH = "USE_SQC_STAR_SQUARE_CASH",
  USE_SQC_STAR_CASH_APP = "USE_SQC_STAR_CASH_APP",
  USE_CASH_APP_STAR = "USE_CASH_APP_STAR",
}

/** Policy to control whether to include in-app promotions to explore Boosts on adding cash. */
export enum ExperimentsUpsellAddCashBoostExplorationPolicy {
  ADD_CASH_BOOST_EXPLORATION_PROMO_DISABLED = "ADD_CASH_BOOST_EXPLORATION_PROMO_DISABLED",
  ADD_CASH_BOOST_EXPLORATION_PROMO_ENABLED = "ADD_CASH_BOOST_EXPLORATION_PROMO_ENABLED",
}

/** Policy to control if a customer should be evaluated for boost with address. */
export enum ExperimentsEvaluateGlobalAddressPolicy {
  EVALUATE_GLOBAL_ADDRESS_DISABLED = "EVALUATE_GLOBAL_ADDRESS_DISABLED",
  EVALUATE_GLOBAL_ADDRESS_ENABLED = "EVALUATE_GLOBAL_ADDRESS_ENABLED",
}

/** Policy to control if we send autoresponses related to autoblocks based off an ML model. */
export enum ExperimentsEnableAutoresponderMergePolicy {
  DO_NOT_SEND_MERGE_AUTORESPONSE = "DO_NOT_SEND_MERGE_AUTORESPONSE",
  SEND_MERGE_AUTORESPONSE = "SEND_MERGE_AUTORESPONSE",
}

export enum ExperimentsEnhancedVerificationIncludeContactsPolicy {
  EXCLUDE_CONTACTS_METHOD = "EXCLUDE_CONTACTS_METHOD",
  INCLUDE_CONTACTS_METHOD = "INCLUDE_CONTACTS_METHOD",
}

export enum ExperimentsEnhancedVerificationIncludeGovernmentIdPolicy {
  EXCLUDE_GOVERNMENT_ID_METHOD = "EXCLUDE_GOVERNMENT_ID_METHOD",
  INCLUDE_GOVERNMENT_ID_METHOD = "INCLUDE_GOVERNMENT_ID_METHOD",
}

export enum ExperimentsEnhancedVerificationIncludePlaidPolicy {
  EXCLUDE_PLAID_METHOD = "EXCLUDE_PLAID_METHOD",
  INCLUDE_PLAID_METHOD = "INCLUDE_PLAID_METHOD",
}

export enum ExperimentsEnhancedVerificationIncludeDebitCardPolicy {
  EXCLUDE_DEBIT_CARD_METHOD = "EXCLUDE_DEBIT_CARD_METHOD",
  INCLUDE_DEBIT_CARD_METHOD = "INCLUDE_DEBIT_CARD_METHOD",
}

/** Controls the soft descriptor prefix and default descriptor for payments and transfers. */
export enum ExperimentsUsSoftDescriptorPrefixPolicy {
  US_USE_SQC_STAR_SQUARE_CASH = "US_USE_SQC_STAR_SQUARE_CASH",
  US_USE_SQC_STAR_CASH_APP = "US_USE_SQC_STAR_CASH_APP",
  US_USE_CASH_APP_STAR = "US_USE_CASH_APP_STAR",
}

/** Policy to decide which outgoing transfer customer to use for GBP cash outs */
export enum ExperimentsGBPOutgoingTransferCustomerPolicy {
  C_OUTGOING_TRANSFER = "C_OUTGOING_TRANSFER",
  C_OUTGOING_TRANSFER_GBP = "C_OUTGOING_TRANSFER_GBP",
}

/**
 * Policy to decide which card reissuing flow to use.
 * The existing flow attempts to monitor or terminate the existing active card pair.
 * TERMINATE_AND_MONITOR_ALL_CARDS will instead terminate or monitor all existing cards
 * when reissuing.
 */
export enum ExperimentsBanklinReissueCardPolicy {
  USE_EXISTING_FLOW = "USE_EXISTING_FLOW",
  TERMINATE_AND_MONITOR_ALL_CARDS = "TERMINATE_AND_MONITOR_ALL_CARDS",
}

/** Controls whether or not banklin uses the denylisted bit to determine if a user is denylisted. */
export enum ExperimentsBanklinDenylistedPolicy {
  BANKLIN_DO_NOT_USE_DENYLISTED = "BANKLIN_DO_NOT_USE_DENYLISTED",
  BANKLIN_USE_DENYLISTED = "BANKLIN_USE_DENYLISTED",
}

export enum ExperimentsUkPaymentCodingCategoryPolicy {
  UK_USE_P2P = "UK_USE_P2P",
  UK_USE_COMMERCIAL = "UK_USE_COMMERCIAL",
}

export enum ExperimentsUkUseSellerMidPolicy {
  UK_USE_SELLER_MID_DISABLED = "UK_USE_SELLER_MID_DISABLED",
  UK_USE_SELLER_MID_ENABLED = "UK_USE_SELLER_MID_ENABLED",
}

/**
 * Policy to simultaneously control payment descriptor, payment coding category, MCC, and pull
 * token for UK transactions only.
 */
export enum ExperimentsUkUseCombinedSellerAttributesPolicy {
  UK_COMBINED_SELLER_ATTRIBUTES_POLICY_DISABLED = "UK_COMBINED_SELLER_ATTRIBUTES_POLICY_DISABLED",
  UK_COMBINED_SELLER_ATTRIBUTES_POLICY_ENABLED = "UK_COMBINED_SELLER_ATTRIBUTES_POLICY_ENABLED",
}

/** Policy to control if expiring instruments should be automatically refreshed. */
export enum ExperimentsInstrumentRefreshPolicy {
  INSTRUMENT_REFRESH_DISABLED = "INSTRUMENT_REFRESH_DISABLED",
  INSTRUMENT_REFRESH_ENABLED = "INSTRUMENT_REFRESH_ENABLED",
}

/**
 * Policy to control whether to include in-app promotions to explore Boosts on successful Cash
 * Card activation.
 */
export enum ExperimentsUpsellActivateCardBoostExplorationPolicy {
  ACTIVATE_CARD_BOOST_EXPLORATION_PROMO_DISABLED = "ACTIVATE_CARD_BOOST_EXPLORATION_PROMO_DISABLED",
  ACTIVATE_CARD_BOOST_EXPLORATION_PROMO_ENABLED = "ACTIVATE_CARD_BOOST_EXPLORATION_PROMO_ENABLED",
}

/**
 * Policy to determine if joins or lazy loading should be used in
 * Authenticator#createCustomerOperator.
 */
export enum ExperimentsCustomerSnapshotLoadingPolicy {
  LAZY_CUSTOMER_SNAPSHOT = "LAZY_CUSTOMER_SNAPSHOT",
  EAGER_JOIN_CUSTOMER_SNAPSHOT = "EAGER_JOIN_CUSTOMER_SNAPSHOT",
}

/**
 * Policy to determine if we should allow customers to have multiple active cards.
 * Before multicard is fully supported, we can use MULTICARD_AS_SINGLE_CARD internally
 * to represent the state where users (mostly Cash employees) may have multiple cards but
 * they are represented in the app as a single card.
 * More buckets may need to be added before multicard is truly supported to represent
 * # different states.
 */
export enum ExperimentsMultiCardsPolicy {
  MULTICARD_UNSUPPORTED = "MULTICARD_UNSUPPORTED",
  MULTICARD_AS_SINGLE_CARD = "MULTICARD_AS_SINGLE_CARD",
  MULTICARD_SUPPORTED = "MULTICARD_SUPPORTED",
}

/**
 * Policy to determine if GetEffectiveCustomerLimitsAppApi should use a read write transaction
 * or a read only transaction.
 */
export enum ExperimentsGetEffectiveCustomerLimitsTransactionPolicy {
  GET_EFFECTIVE_CUSTOMER_LIMITS_READ_WRITE = "GET_EFFECTIVE_CUSTOMER_LIMITS_READ_WRITE",
  GET_EFFECTIVE_CUSTOMER_LIMITS_READ_ONLY = "GET_EFFECTIVE_CUSTOMER_LIMITS_READ_ONLY",
}

/** Customers in this experiment will not be subject to the default deposit limits of the system */
export enum ExperimentsOverrideBitcoinDepositLimit {
  OVERRIDE_DEPOSIT_LIMIT_DISABLED = "OVERRIDE_DEPOSIT_LIMIT_DISABLED",
  OVERRIDE_DEPOSIT_LIMIT_ENABLED = "OVERRIDE_DEPOSIT_LIMIT_ENABLED",
}

/**
 * Controls whether the customer is allowed to link their Cash Card to their account.
 * Internal use only!
 */
export enum ExperimentsLinkSquareIssuedCardPolicy {
  LINK_SQUARE_ISSUED_CARD_DISABLED = "LINK_SQUARE_ISSUED_CARD_DISABLED",
  LINK_SQUARE_ISSUED_CARD_ENABLED = "LINK_SQUARE_ISSUED_CARD_ENABLED",
}

/** Policy to set the minimum transfer amount for a customer. */
export enum ExperimentsMinimumTransferAmountPolicy {
  MIN_MAIN_CURRENCY_UNIT = "MIN_MAIN_CURRENCY_UNIT",
  MIN_FRACTIONAL_CURRENCY_UNIT = "MIN_FRACTIONAL_CURRENCY_UNIT",
}

/** Policy to determine if emergency cards can be issued. */
export enum ExperimentsEmergencyCardPolicy {
  DISALLOW_ISSUE_OF_EMERGENCY_CARD = "DISALLOW_ISSUE_OF_EMERGENCY_CARD",
  ALLOW_ISSUE_OF_EMERGENCY_CARD = "ALLOW_ISSUE_OF_EMERGENCY_CARD",
  ALLOW_AUTO_CARD_ISSUING = "ALLOW_AUTO_CARD_ISSUING",
}

/** Policy to determine if LinkCardAppApi should use a read-only or read-write transaction. */
export enum ExperimentsLinkCardAppApiTransacterModePolicy {
  LINK_CARD_TRANSACTER_READ_WRITE = "LINK_CARD_TRANSACTER_READ_WRITE",
  LINK_CARD_TRANSACTER_READ_ONLY = "LINK_CARD_TRANSACTER_READ_ONLY",
}

/**
 * Policy to determine if we respect plaid settings when deciding to
 * include a bank account node in EV Flow.
 */
export enum ExperimentsEnhancedVerificationIgnorePlaidSettingsPolicy {
  RESPECT_PLAID_SETTINGS = "RESPECT_PLAID_SETTINGS",
  IGNORE_PLAID_SETTINGS = "IGNORE_PLAID_SETTINGS",
}

/** Policy to determine if we call frisky, or directly approve/reject GovernmentId sources. */
export enum ExperimentsEnhancedVerificationHandleGovernmentId {
  CALL_FRISKY_GOVERNMENT_ID = "CALL_FRISKY_GOVERNMENT_ID",
  APPROVE_GOVERNMENT_ID = "APPROVE_GOVERNMENT_ID",
  REJECT_GOVERNMENT_ID = "REJECT_GOVERNMENT_ID",
}

/** Policy to determine if we call frisky, or directly approve/reject Contacts sources. */
export enum ExperimentsEnhancedVerificationHandleContacts {
  CALL_FRISKY_CONTACTS = "CALL_FRISKY_CONTACTS",
  APPROVE_CONTACTS = "APPROVE_CONTACTS",
  REJECT_CONTACTS = "REJECT_CONTACTS",
}

/** Policy to determine if we call frisky, or directly approve/reject Plaid sources. */
export enum ExperimentsEnhancedVerificationHandlePlaid {
  CALL_FRISKY_PLAID = "CALL_FRISKY_PLAID",
  APPROVE_PLAID = "APPROVE_PLAID",
  REJECT_PLAID = "REJECT_PLAID",
}

/** Policy to decide if suspended customers should be deflected from contacting support. */
export enum ExperimentsSuspendedCustomerSupportHandlingPolicy {
  SUSPENDED_CUSTOMER_NORMAL_HANDLING = "SUSPENDED_CUSTOMER_NORMAL_HANDLING",
  SUSPENDED_CUSTOMER_DEPRIORITIZED_HANDLING = "SUSPENDED_CUSTOMER_DEPRIORITIZED_HANDLING",
}

/**
 * Policy to control Boost treasure hunt feature (Hack Week 2019).
 * This has been deprecated.
 */
export enum ExperimentsBoostTreasureHuntPolicy {
  BOOST_TREASURE_HUNT_DISABLED = "BOOST_TREASURE_HUNT_DISABLED",
  BOOST_TREASURE_HUNT_ENABLED = "BOOST_TREASURE_HUNT_ENABLED",
}

/** Policy to control whether or not we allow Lightning Bitcoin payments. */
export enum ExperimentsBitcoinLightningPolicy {
  LIGHTNING_DISABLED = "LIGHTNING_DISABLED",
  LIGHTNING_ENABLED = "LIGHTNING_ENABLED",
}

/** Policy to decide if a user can deposit a check using remote check deposit */
export enum ExperimentsRemoteCheckDepositPolicy {
  REMOTE_CHECK_DEPOSIT_DISABLED = "REMOTE_CHECK_DEPOSIT_DISABLED",
  REMOTE_CHECK_DEPOSIT_ENABLED = "REMOTE_CHECK_DEPOSIT_ENABLED",
}

/** Policy to control whether or not we show Bill Pay pages (for Pay with Cash). */
export enum ExperimentsPayWithCashPayPagePolicy {
  PAY_PAGE_DISABLED = "PAY_PAGE_DISABLED",
  PAY_PAGE_ENABLED = "PAY_PAGE_ENABLED",
}

/** Policy to determine which bank to issue a DDA with (e.g. LINCOLN_SAVINGS or SUTTON) */
export enum ExperimentsDemandDepositAccountIssuingPolicy {
  ISSUE_ON_LINCOLN_SAVINGS = "ISSUE_ON_LINCOLN_SAVINGS",
  ISSUE_ON_SUTTON = "ISSUE_ON_SUTTON",
}

/** Policy to control auto buy bitcoin with ACH deposit (Hack Week 2019). */
export enum ExperimentsHackweekAutoBuyBitcoinForAchPolicy {
  AUTO_BUY_BITCOIN_DISABLED = "AUTO_BUY_BITCOIN_DISABLED",
  AUTO_BUY_BITCOIN_ENABLED = "AUTO_BUY_BITCOIN_ENABLED",
}

/** Policy to control which customers are allowed to link to billing institution bank accounts. */
export enum ExperimentsInstitutionBankLinkPolicy {
  INSTITUTION_BANK_LINK_DISABLED = "INSTITUTION_BANK_LINK_DISABLED",
  INSTITUTION_BANK_LINK_ENABLED = "INSTITUTION_BANK_LINK_ENABLED",
}

export enum ExperimentsCardOnboardingDisclosurePolicy {
  CARD_ONBOARDING_DISCLOSURE_DISABLED = "CARD_ONBOARDING_DISCLOSURE_DISABLED",
  CARD_ONBOARDING_DISCLOSURE_ENABLED = "CARD_ONBOARDING_DISCLOSURE_ENABLED",
}

/** Policy to control whether suspended customers should have bitcoin purchases fail. */
export enum ExperimentsSuspensionBitcoinPolicy {
  SUSPENSION_BITCOIN_ALLOWED = "SUSPENSION_BITCOIN_ALLOWED",
  SUSPENSION_BITCOIN_PROHIBITED = "SUSPENSION_BITCOIN_PROHIBITED",
}

/** Controls if upfront balance checks are enabled. */
export enum ExperimentsUpfrontBalanceChecksPolicy {
  UPFRONT_BALANCE_CHECKS_DISABLED = "UPFRONT_BALANCE_CHECKS_DISABLED",
  UPFRONT_BALANCE_CHECKS_WITH_PLAID_ENABLED = "UPFRONT_BALANCE_CHECKS_WITH_PLAID_ENABLED",
}

/** Policy for whether to process bizbank card transactions through Cardly */
export enum ExperimentsCardProcessBizbankTransactionPolicy {
  PROCESS_BIZBANK_TRANSACTION_IN_BANKLIN = "PROCESS_BIZBANK_TRANSACTION_IN_BANKLIN",
  PROCESS_BIZBANK_TRANSACTION_THROUGH_CARDLY = "PROCESS_BIZBANK_TRANSACTION_THROUGH_CARDLY",
}

/** Policy to enable using generic form blocker for Yodlee MFA form. */
export enum ExperimentsYodleeFormBlockerPolicy {
  FORM_BLOCKER_FOR_YODLEE_MFA_DISABLED = "FORM_BLOCKER_FOR_YODLEE_MFA_DISABLED",
  FORM_BLOCKER_FOR_YODLEE_MFA_ENABLED = "FORM_BLOCKER_FOR_YODLEE_MFA_ENABLED",
}

/** Enables experimental ACH soft descriptors for testing. */
export enum ExperimentsExperimentalAchSoftDescriptorPolicy {
  EXPERIMENTAL_ACH_SOFT_DESCRIPTOR_DISABLED = "EXPERIMENTAL_ACH_SOFT_DESCRIPTOR_DISABLED",
  EXPERIMENTAL_ACH_SOFT_DESCRIPTOR_ENABLED = "EXPERIMENTAL_ACH_SOFT_DESCRIPTOR_ENABLED",
  CASH_APP_IN_ACH_SOFT_DESCRIPTOR = "CASH_APP_IN_ACH_SOFT_DESCRIPTOR",
}

/** Controls whether emails are sent via EmailBridge or via Raven's EmailBridge compatibility mode. */
export enum ExperimentsEmailSendingPolicy {
  SEND_EMAILS_VIA_EMAILBRIDGE = "SEND_EMAILS_VIA_EMAILBRIDGE",
  SEND_EMAILS_VIA_RAVEN_MESSAGES = "SEND_EMAILS_VIA_RAVEN_MESSAGES",
}

/** Policy to enable resolving requirements in Plasma. */
export enum ExperimentsPlasmaFlowsPolicy {
  PLASMA_FLOWS_DISABLED = "PLASMA_FLOWS_DISABLED",
  /**
   * PLASMA_FLOWS_ENABLED - Each time we resolve a blocker in Franklin, we also resolve a corresponding requirement in
   * Plasma. This applies only to blockers that are already ported to Plasma.
   */
  PLASMA_FLOWS_ENABLED = "PLASMA_FLOWS_ENABLED",
}

/**
 * Determine how to handle blockers for a payment. Phases are inclusive of all previous phases.
 * PHASE_{N+1} does at least everything PHASE_N does.
 */
export enum ExperimentsPaymentPlasmaMigrationPolicy {
  FRANKLIN_ONLY = "FRANKLIN_ONLY",
  /** PHASE_ONE - Bill getter confirmation FRANKLIN_AND_PLASMA. * */
  PHASE_ONE = "PHASE_ONE",
  /** PHASE_TWO - All confirmation without passcode FRANKLIN_AND_PLASMA. */
  PHASE_TWO = "PHASE_TWO",
  /** PHASE_THREE - All confirmation FRANKLIN_AND_PLASMA. */
  PHASE_THREE = "PHASE_THREE",
  PHASE_FOUR = "PHASE_FOUR",
  PHASE_FIVE = "PHASE_FIVE",
  PHASE_SIX = "PHASE_SIX",
  PLASMA_ONLY = "PLASMA_ONLY",
}

/** Policy to control /$cashtag page refresh in Spring 2019 */
export enum ExperimentsCashtagPageRefreshSpring2019Policy {
  CASHTAG_PAGE_REFRESH_DISABLED = "CASHTAG_PAGE_REFRESH_DISABLED",
  CASHTAG_PAGE_REFRESH_ENABLED = "CASHTAG_PAGE_REFRESH_ENABLED",
}

/** Policy to control /payments/TOKEN/receipt page refresh in Spring 2019 */
export enum ExperimentsReceiptPageRefreshSpring2019Policy {
  RECEIPT_PAGE_REFRESH_DISABLED = "RECEIPT_PAGE_REFRESH_DISABLED",
  RECEIPT_PAGE_REFRESH_ENABLED = "RECEIPT_PAGE_REFRESH_ENABLED",
}

/**
 * Determines whether transactions should be ledgered via Ledgering, or if they should be
 * created directly using TransactionOperator
 */
export enum ExperimentsBanklinLedgeringPolicy {
  DIRECT_TO_TRANSACTION_OPERATOR = "DIRECT_TO_TRANSACTION_OPERATOR",
  VIA_LEDGERING = "VIA_LEDGERING",
}

/** Policy to determine if remove boost flow should go over Plasma. */
export enum ExperimentsPlasmaRemoveBoostFlowPolicy {
  PLASMA_REMOVE_BOOST_FLOW_DISABLED = "PLASMA_REMOVE_BOOST_FLOW_DISABLED",
  PLASMA_REMOVE_BOOST_FLOW_ENABLED = "PLASMA_REMOVE_BOOST_FLOW_ENABLED",
}

/** Policy to determine if add boost flow should go over Plasma. */
export enum ExperimentsPlasmaAddBoostFlowPolicy {
  PLASMA_ADD_BOOST_FLOW_DISABLED = "PLASMA_ADD_BOOST_FLOW_DISABLED",
  PLASMA_ADD_BOOST_FLOW_ENABLED = "PLASMA_ADD_BOOST_FLOW_ENABLED",
}

/**
 * Policy to determine if UK card pulls should be dynamically routed to Seller based on BIN
 * and amount.
 */
export enum ExperimentsUkDynamicPullRoutingPolicy {
  UK_DYNAMIC_PULL_ROUTING_DISABLED = "UK_DYNAMIC_PULL_ROUTING_DISABLED",
  UK_DYNAMIC_PULL_ROUTING_ENABLED = "UK_DYNAMIC_PULL_ROUTING_ENABLED",
}

/** Controls the stages for migrating a customer's DbProfileAssets to using SyncValues. */
export enum ExperimentsSyncValuesMigrationForProfileAssets {
  SYNC_VALUES_DISABLED = "SYNC_VALUES_DISABLED",
  SYNC_VALUES_SHADOW_WRITE = "SYNC_VALUES_SHADOW_WRITE",
  SYNC_VALUES_VERIFY = "SYNC_VALUES_VERIFY",
  SYNC_VALUES_ENABLED = "SYNC_VALUES_ENABLED",
}

/** Policy to determine if eligible customers should have their ATM fees reimbursed. */
export enum ExperimentsFreeAtmStatusPolicy {
  FREE_ATM_STATUS_DISABLED = "FREE_ATM_STATUS_DISABLED",
  FREE_ATM_STATUS_ENABLED = "FREE_ATM_STATUS_ENABLED",
}

/** Policy to determine if we should run the unlinked refund rule when processing card transactions */
export enum ExperimentsUnlinkedRefundRulePolicy {
  UNLINKED_REFUND_RULE_ENABLED = "UNLINKED_REFUND_RULE_ENABLED",
  UNLINKED_REFUND_RULE_DISABLED = "UNLINKED_REFUND_RULE_DISABLED",
}

export enum ExperimentsBusinessPaymentsExpirationPolicy {
  /** LEGACY_BUSINESS_PAYMENTS_EXPIRATION - Legacy business payments had 3 years expiration and were not cancellable. */
  LEGACY_BUSINESS_PAYMENTS_EXPIRATION = "LEGACY_BUSINESS_PAYMENTS_EXPIRATION",
  /**
   * BUSINESS_PAYMENTS_EXPIRE_IN_14_DAYS - Decided with @jessbullitt, @dustin and @boates that all new business payments get same
   * expiration policy as non-business ones.
   * https://square.slack.com/archives/C5Y4L7PDL/p1557266539491500
   */
  BUSINESS_PAYMENTS_EXPIRE_IN_14_DAYS = "BUSINESS_PAYMENTS_EXPIRE_IN_14_DAYS",
}

export enum ExperimentsOnboardingReferralCodeUsPolicy {
  DO_NOT_PREFILL_REWARD_CODE_US = "DO_NOT_PREFILL_REWARD_CODE_US",
  PREFILL_REWARD_CODE_US = "PREFILL_REWARD_CODE_US",
}

/** Show an explicit confirmation blocker for bills from outside of contacts. */
export enum ExperimentsBillFromOutsideOfContactsPolicy {
  SHOW_CONFIRMATION_BLOCKER_DISABLED = "SHOW_CONFIRMATION_BLOCKER_DISABLED",
  SHOW_CONFIRMATION_BLOCKER_ENABLED = "SHOW_CONFIRMATION_BLOCKER_ENABLED",
  /**
   * SHOW_CONFIRMATION_BLOCKER_AND_IGNORE_PROXIMITY - There's a customer to customer "close in proximity" exception, i.e., if the customers are
   * close-by don't show the blocker. Select this to ignore that extra condition. This is
   * mainly for testing purposes.
   */
  SHOW_CONFIRMATION_BLOCKER_AND_IGNORE_PROXIMITY = "SHOW_CONFIRMATION_BLOCKER_AND_IGNORE_PROXIMITY",
}

/** Policy to determine if we should evaluate a customer's current location for travel boost. */
export enum ExperimentsTravelBoostPolicy {
  TRAVEL_BOOST_EVALUATION_DISABLED = "TRAVEL_BOOST_EVALUATION_DISABLED",
  TRAVEL_BOOST_EVALUATION_ENABLED = "TRAVEL_BOOST_EVALUATION_ENABLED",
}

export enum ExperimentsWhiteCardPolicy {
  WHITE_CARD_DISABLED = "WHITE_CARD_DISABLED",
  DEFAULT_BLACK_CARD = "DEFAULT_BLACK_CARD",
  DEFAULT_WHITE_CARD = "DEFAULT_WHITE_CARD",
}

export enum ExperimentsBtcSellIdvBlockerPolicy {
  IDV_BLOCKERS_DISABLED = "IDV_BLOCKERS_DISABLED",
  IDV_BLOCKERS_ENABLED = "IDV_BLOCKERS_ENABLED",
}

export enum ExperimentsApplePayWithTabsPolicy {
  APPLE_PAY_WITH_TABS_ENABLED = "APPLE_PAY_WITH_TABS_ENABLED",
  APPLE_PAY_WITH_TABS_DISABLED = "APPLE_PAY_WITH_TABS_DISABLED",
}

/**
 * Policy to control the migration of transaction related sync entities: transactions, merchants,
 * and customers.
 */
export enum ExperimentsTransactionRelatedSyncEntitiesMigrationPolicy {
  WRITE_TO_FRANKLIN_READ_FROM_FRANKLIN = "WRITE_TO_FRANKLIN_READ_FROM_FRANKLIN",
  WRITE_TO_BOTH_READ_FROM_BOTH = "WRITE_TO_BOTH_READ_FROM_BOTH",
  WRITE_TO_BOTH_READ_FROM_CLIENT_SYNC = "WRITE_TO_BOTH_READ_FROM_CLIENT_SYNC",
}

/** Enable an extra delay of ACH cash outs to make them slower. */
export enum ExperimentsSlowAchCashOutPolicy {
  SLOW_ACH_CASH_OUT_DISABLED = "SLOW_ACH_CASH_OUT_DISABLED",
  SLOW_ACH_CASH_OUT_ENABLED = "SLOW_ACH_CASH_OUT_ENABLED",
}

export enum ExperimentsCustomerAddressMasterCardPaymentPolicy {
  /** REDACT_CUSTOMER_ADDRESS - Replace the customer's street number and name with that of Square's US office. */
  REDACT_CUSTOMER_ADDRESS = "REDACT_CUSTOMER_ADDRESS",
  USE_REAL_CUSTOMER_ADDRESS = "USE_REAL_CUSTOMER_ADDRESS",
}

/** Enables handling of concurrent modifications by TwinOperator. */
export enum ExperimentsTwinOperatorConcurrentModificationsPolicy {
  TWIN_OPERATOR_CONCURRENT_MODIFICATIONS_NOT_HANDLED = "TWIN_OPERATOR_CONCURRENT_MODIFICATIONS_NOT_HANDLED",
  TWIN_OPERATOR_CONCURRENT_MODIFICATIONS_HANDLED = "TWIN_OPERATOR_CONCURRENT_MODIFICATIONS_HANDLED",
}

export enum ExperimentsCustomerStatementNameMasterCardPaymentPolicy {
  /** USE_FRIENDLY_NAME - Use the customer's friendly name on MasterCard payment statements. */
  USE_FRIENDLY_NAME = "USE_FRIENDLY_NAME",
  /**
   * USE_VERIFIED_FULL_NAME_IF_AVAILABLE - If a verified full name is available, then use it on MasterCard payment statements,
   * otherwise use the customer's friendly name.
   */
  USE_VERIFIED_FULL_NAME_IF_AVAILABLE = "USE_VERIFIED_FULL_NAME_IF_AVAILABLE",
}

export enum ExperimentsMasterCardStatementLastNameSubstitutionPolicy {
  /** SUBSTITUTE_UNKNOWN_FOR_EMPTY_LAST_NAME - Substitute "Unknown" for a missing last name. */
  SUBSTITUTE_UNKNOWN_FOR_EMPTY_LAST_NAME = "SUBSTITUTE_UNKNOWN_FOR_EMPTY_LAST_NAME",
  /** ALLOW_EMPTY_LAST_NAME - Leave the last name empty if it is empty. */
  ALLOW_EMPTY_LAST_NAME = "ALLOW_EMPTY_LAST_NAME",
  /** SUBSTITUTE_NONE_FOR_EMPTY_LAST_NAME - Substitute "None" for a missing last name. */
  SUBSTITUTE_NONE_FOR_EMPTY_LAST_NAME = "SUBSTITUTE_NONE_FOR_EMPTY_LAST_NAME",
}

/** Migration policy of SyncPayments to ClientSync. */
export enum ExperimentsClientSyncPaymentsMigrationPolicy {
  WRITE_FRANKLIN_ONLY = "WRITE_FRANKLIN_ONLY",
  WRITE_BOTH_SYNC_FRANKLIN_ONLY = "WRITE_BOTH_SYNC_FRANKLIN_ONLY",
  /** WRITE_BOTH_PREFER_FRANKLIN - When there are (entity_id, entity_type) duplicates we de-dup by choosing the one from franklin. */
  WRITE_BOTH_PREFER_FRANKLIN = "WRITE_BOTH_PREFER_FRANKLIN",
  /** WRITE_BOTH_PREFER_CLIENTSYNC - Similarly for ClientSync. */
  WRITE_BOTH_PREFER_CLIENTSYNC = "WRITE_BOTH_PREFER_CLIENTSYNC",
}

/** MoneyMover is a cloud service. Currently only a fake client used in tests exists. */
export enum ExperimentsMoneyMoverMigrationPolicy {
  MONEY_MOVER_DISABLED = "MONEY_MOVER_DISABLED",
  MONEY_MOVER_ENABLED = "MONEY_MOVER_ENABLED",
}

export enum ExperimentsBitcoinTransactionPricingPolicy {
  /** SPREAD - Original spread based pricing. */
  SPREAD = "SPREAD",
  /** PERCENTAGE_125_BPS - Percentage based 1.25%. */
  PERCENTAGE_125_BPS = "PERCENTAGE_125_BPS",
  /** PERCENTAGE_175_BPS - Percentage based 1.75%. */
  PERCENTAGE_175_BPS = "PERCENTAGE_175_BPS",
}

export enum ExperimentsPaymentEventlyMigration {
  /** ARCHIVER_ONLY - Publish on archiver only, consume on archiver only. */
  ARCHIVER_ONLY = "ARCHIVER_ONLY",
  /** CONSUME_ARCHIVER - Publish on both, consume on archiver. */
  CONSUME_ARCHIVER = "CONSUME_ARCHIVER",
  /** CONSUME_EVENTLY - Publish on both, consume on evently. */
  CONSUME_EVENTLY = "CONSUME_EVENTLY",
  /** EVENTLY_ONLY - Publish on evently only, consume on evently only. */
  EVENTLY_ONLY = "EVENTLY_ONLY",
}

/** Controls how Amex pulls are sub-categorized. */
export enum ExperimentsAmexSubcategoryConversionPolicy {
  USE_CASH_PRO_PURCHASE_FOR_ALL_COMMERCIAL = "USE_CASH_PRO_PURCHASE_FOR_ALL_COMMERCIAL",
  USE_CASH_P2P_FOR_ALL_COMMERCIAL = "USE_CASH_P2P_FOR_ALL_COMMERCIAL",
}

/**
 * We use BitcoinTransactionPricingPolicy to run the experiment of the Bitcoin pricing
 * change on new customers, i.e. customers who haven't bought or sold bitcoin before
 * the cut off date defined by the feature flag cashserver/btc_pricing_experiment_cutoff_date
 * We use this BitcoinBeforeCutoffPricingPolicy to run another experiment on existing customers,
 * i.e. customer who have bought or sold Bitcoin before the cutoff. There two experiments
 * should be mutual exclusive.
 */
export enum ExperimentsBitcoinBeforeCutoffPricingPolicy {
  /** BEFORE_CUTOFF_SPREAD - Original spread based pricing. */
  BEFORE_CUTOFF_SPREAD = "BEFORE_CUTOFF_SPREAD",
  /** BEFORE_CUTOFF_PERCENTAGE_125_BPS - Percentage based 1.25%. */
  BEFORE_CUTOFF_PERCENTAGE_125_BPS = "BEFORE_CUTOFF_PERCENTAGE_125_BPS",
  /** BEFORE_CUTOFF_PERCENTAGE_175_BPS - Percentage based 1.75%. */
  BEFORE_CUTOFF_PERCENTAGE_175_BPS = "BEFORE_CUTOFF_PERCENTAGE_175_BPS",
}

/**
 * Commercial Amex pulls might be getting rejected more frequently because of the
 * AmexSubcategoryConversionPolicy experiment being turned on. This experiment is to try and
 * make pulls being sub-categorized as P2P also get the same MCC and Address as P2P.
 */
export enum ExperimentsAmexMccAndAddressOverridePolicy {
  /** DEFAULT - Do not override anything. */
  DEFAULT = "DEFAULT",
  /** OVERRIDE_MCC - Override MCC for Commercial "P2P" Amex. */
  OVERRIDE_MCC = "OVERRIDE_MCC",
  /** OVERRIDE_ADDRESS - Override Address for Commercial "P2P" Amex. */
  OVERRIDE_ADDRESS = "OVERRIDE_ADDRESS",
  /** OVERRIDE_MCC_AND_ADDRESS - Override MCC and Address for Commercial "P2P" Amex. */
  OVERRIDE_MCC_AND_ADDRESS = "OVERRIDE_MCC_AND_ADDRESS",
}

/**
 * We'd like to try relaxing the referral payout requirement of linking an expensive instrument
 * if the referral was created by an invitation.
 */
export enum ExperimentsExpensiveInstrumentsForInvitedCustomersReferralPayoutPolicy {
  REQUIRE_EXPENSIVE_INSTRUMENTS = "REQUIRE_EXPENSIVE_INSTRUMENTS",
  DO_NOT_REQUIRE_EXPENSIVE_INSTRUMENTS = "DO_NOT_REQUIRE_EXPENSIVE_INSTRUMENTS",
}

/**
 * We'd like to try relaxing the referral payout requirement of linking a previously unused
 * instrument if the referral was created by an invitation.
 */
export enum ExperimentsUnusedInstrumentsForInvitedCustomersReferralPayoutPolicy {
  REQUIRE_UNUSED_INSTRUMENTS = "REQUIRE_UNUSED_INSTRUMENTS",
  DO_NOT_REQUIRE_UNUSED_INSTRUMENTS = "DO_NOT_REQUIRE_UNUSED_INSTRUMENTS",
}

/**
 * We'd like to try relaxing the referral payout requirement of completing IDV if the referral
 * was created by an invitation.
 */
export enum ExperimentsIdvForInvitedCustomersReferralPayoutPolicy {
  REQUIRE_IDV = "REQUIRE_IDV",
  DO_NOT_REQUIRE_IDV = "DO_NOT_REQUIRE_IDV",
}

export enum ExperimentsBitcoinTransactionGraduatedPricingPolicy {
  /** PERCENTAGE_FIXED_175_BPS - Original 175 bps pricing. */
  PERCENTAGE_FIXED_175_BPS = "PERCENTAGE_FIXED_175_BPS",
  /** PERCENTAGE_GRADUATED_HIGH - Graduated scaled pricing. Their definitions are in CRYPTO-235. */
  PERCENTAGE_GRADUATED_HIGH = "PERCENTAGE_GRADUATED_HIGH",
  PERCENTAGE_GRADUATED_MIDDLE = "PERCENTAGE_GRADUATED_MIDDLE",
  PERCENTAGE_GRADUATED_LOW = "PERCENTAGE_GRADUATED_LOW",
  PERCENTAGE_GRADUATED_HIGH_TO_LOW = "PERCENTAGE_GRADUATED_HIGH_TO_LOW",
}

export enum ExperimentsBitcoinTransactionGraduatedPricingV2Policy {
  /** PERCENTAGE_FIXED_175_BPS_V2 - Original 175 bps pricing. */
  PERCENTAGE_FIXED_175_BPS_V2 = "PERCENTAGE_FIXED_175_BPS_V2",
  /** PERCENTAGE_GRADUATED_LOW_V2 - Graduated scaled pricing. Their definitions are in go/btcpricingv2 */
  PERCENTAGE_GRADUATED_LOW_V2 = "PERCENTAGE_GRADUATED_LOW_V2",
  /** PERCENTAGE_GRADUATED_HIGH_TO_LOW_V2 - HIGH_TO_LOW means pricing percent is high with small transaction, but lower with large transaction. */
  PERCENTAGE_GRADUATED_HIGH_TO_LOW_V2 = "PERCENTAGE_GRADUATED_HIGH_TO_LOW_V2",
  /** PERCENTAGE_GRADUATED_MIDDLE_TO_LOW_V2 - MIDDLE_TO_LOW is similar to the pricing policy above, but the percent is lower for small transaction. */
  PERCENTAGE_GRADUATED_MIDDLE_TO_LOW_V2 = "PERCENTAGE_GRADUATED_MIDDLE_TO_LOW_V2",
}

/**
 * For customers who haven't bought or sold bitcoin before the cut off date defined by
 * the feature flag cashserver/btc_pricing_experiment_cutoff_date.
 */
export enum ExperimentsBitcoinBeforeCutoffTransactionGraduatedPricingPolicy {
  /** BEFORE_CUTOFF_PERCENTAGE_FIXED_175_BPS - Original 175 bps pricing. */
  BEFORE_CUTOFF_PERCENTAGE_FIXED_175_BPS = "BEFORE_CUTOFF_PERCENTAGE_FIXED_175_BPS",
  /** BEFORE_CUTOFF_PERCENTAGE_GRADUATED_LOW - Graduated scaled pricing. Their definitions are in go/btcpricingv2 */
  BEFORE_CUTOFF_PERCENTAGE_GRADUATED_LOW = "BEFORE_CUTOFF_PERCENTAGE_GRADUATED_LOW",
  /** BEFORE_CUTOFF_PERCENTAGE_GRADUATED_HIGH_TO_LOW - HIGH_TO_LOW means pricing percent is high with small transaction, but lower with large transaction. */
  BEFORE_CUTOFF_PERCENTAGE_GRADUATED_HIGH_TO_LOW = "BEFORE_CUTOFF_PERCENTAGE_GRADUATED_HIGH_TO_LOW",
  /** BEFORE_CUTOFF_PERCENTAGE_GRADUATED_MIDDLE_TO_LOW - MIDDLE_TO_LOW is similar to the pricing policy above, but the percent is lower for small transaction. */
  BEFORE_CUTOFF_PERCENTAGE_GRADUATED_MIDDLE_TO_LOW = "BEFORE_CUTOFF_PERCENTAGE_GRADUATED_MIDDLE_TO_LOW",
}
